<div class="header">
    <div class="header-left">
        <button *ngIf="currentComponent === 'details'" class="back-button" (click)="navigateBack()">
            <img src="assets/icones/close_icon.svg" alt="">
        </button>

        <button
            *ngIf="['products', 'products-from-catalog', 'products-from-all-products', 'source-content', 'explore_catalog'].includes(currentComponent)"
            class="back-button"
            (click)="backTo()" >
            <img src="assets/icones/navigate-back-arrow.svg" alt="">
        </button>

        <div class="breadcrumb-item">{{ "breadcrumbs.orders" | translate }}</div>

        <ng-container *ngIf="['explore_catalog', 'products-from-catalog'].includes(currentComponent)">
            <img src="assets/icones/arrow_to_right.svg" alt="">
            <div class="breadcrumb-item">{{ "quotations_and_orders.new_order" | translate }}</div>

            <img src="assets/icones/arrow_to_right.svg" alt="">
            <div class="breadcrumb-item quotation-title">{{ "quotations_and_orders.catalogs" | translate }}</div>
        </ng-container>

        <ng-container *ngIf="currentComponent === 'products-from-all-products'">
            <img src="assets/icones/arrow_to_right.svg" alt="">
            <div class="breadcrumb-item">{{ "Catalogs.al_product" | translate }}</div>
        </ng-container>

        <ng-container *ngIf="!['explore_catalog','products-from-catalog'].includes(currentComponent)
                && (quotation$ | async) as quotation">

            <img src="assets/icones/arrow_to_right.svg" alt="">
            <div class="breadcrumb-item"
                [ngClass]="{
                    'quotation-name': currentComponent === 'details'
                }">
                {{ quotation.name }}
            </div>

            <ng-container *ngIf="['products'].includes(currentComponent)">
                <img src="assets/icones/arrow_to_right.svg" alt="">
                <div class="breadcrumb-item quotation-title">{{ "quotations_and_orders.product" | translate }}</div>
            </ng-container>

            <ng-container *ngIf="currentComponent === 'source-content'">
                <img src="assets/icones/arrow_to_right.svg" alt="">
                <div class="breadcrumb-item quotation-title volta-ai-text">
                    {{ "quotations_and_orders.email" | translate }}
                </div>
            </ng-container>
            <app-order-header-tags
                *ngIf="currentComponent === 'details'"
                [quotation]="quotation"
                [segregationCheck]="segregationCheck"
                (splitClick)="openSplitPreview()"
                (duplicateDismissed)="dismissDuplicateBadge()">
            </app-order-header-tags>
        </ng-container>

    </div>
    <div class="header-actions" *ngIf="(quotation$ | async) as quotation">
        <ng-container class="header-actions-quotes" *ngIf="currentComponent === 'details'">
            <!-- Fallback actions menu for statuses without a dedicated menu (sent, sale, done, cancel, declined) -->
            <ng-container *ngIf="!['draft', 'requested', 'to_be_validated', 'pending_inventory'].includes(quotation!.status) && !isQuotationArchived(quotation)">
                <div class="menu_btn">
                    <button class="secondary_btns" data-testid="order-actions-menu" mat-icon-button [matMenuTriggerFor]="fallbackMenu" aria-label="Order actions">
                        <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
                    </button>
                    <mat-menu #fallbackMenu="matMenu">
                        <button mat-menu-item class="menu_item" data-testid="order-action-duplicate" (click)="confirmAction('duplicate_order')">
                            <img src="assets/icones/copy.svg" alt="" onerror="this.style.display='none'">
                            <span>{{ 'quotations_and_orders.actions.duplicate' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canShowArchiveAction(quotation)" data-testid="order-action-archive" (click)="confirmAction('archive_order')">
                            <img src="assets/icones/archive.svg" alt="" onerror="this.style.display='none'">
                            <span>{{ 'quotations_and_orders.actions.archive' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canShowDeleteAction(quotation)" data-testid="order-action-delete" (click)="confirmAction('delete_order')">
                            <img src="assets/icones/cancel_icon.svg" alt="">
                            <span>{{"common.delete_order"|translate}}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="hasEnrichableCodes && canCreateKbReference" (click)="openEnrichFromMenu()">
                            <img src="assets/icones/ai-volta-icon.svg" alt="" width="24" height="24" onerror="this.style.display='none'">
                            <span>{{ 'quotations_and_orders.enrich_external_references.enrich_action' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </ng-container>
            <!-- unarchive button (visible for archived orders, replaces Archive in menu) -->
            <button *ngIf="isQuotationArchived(quotation)" class="btn btn-primary" data-testid="order-action-unarchive" (click)="confirmAction('unarchive_order')">
                <img class="btn-icon" src="assets/icones/check_icon.svg" alt="">
                <span>{{ 'quotations_and_orders.actions.unarchive' | translate }}</span>
            </button>

            <!-- Draft actions (send, send & accept) -->
            <ng-container *ngIf="quotation!.status === 'draft' && !isQuotationArchived(quotation)">
                <div class="menu_btn" *ngIf="canDeleteOrder || (hasEnrichableCodes && canCreateKbReference)">
                    <button class="secondary_btns" data-testid="order-actions-menu" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder" data-testid="order-action-duplicate" (click)="confirmAction('duplicate_order')">
                          <img src="assets/icones/copy.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.duplicate' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowArchiveAction(quotation)" data-testid="order-action-archive" (click)="confirmAction('archive_order')">
                          <img src="assets/icones/archive.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.archive' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowDeleteAction(quotation)" data-testid="order-action-delete" (click)="confirmAction('delete_order')">
                          <img src="assets/icones/cancel_icon.svg" alt="">
                          <span>{{"common.delete_order"|translate}}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="hasEnrichableCodes && canCreateKbReference" (click)="openEnrichFromMenu()">
                          <img src="assets/icones/ai-volta-icon.svg" alt="" width="24" height="24" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.enrich_external_references.enrich_action' | translate }}</span>
                        </button>
                      </mat-menu>
                </div>

                <!-- Send Button -->
                <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                    <button *ngIf="quotation.channel !== 'Agent portal'" class="btn btn-secondary" data-testid="order-action-send" (click)="confirmAction(quotation!.status)" [disabled]="!hasProducts">
                        <img class="btn-icon" [src]="!hasProducts ? 'assets/icones/send-quote-Disabled.svg' : 'assets/icones/send.svg'" alt="">
                        <span>{{ 'quotations_and_orders.send_quote' | translate }}</span>
                    </button>
                </ng-container>
                <!-- Send & Accept Button -->
                <button class="btn btn-primary" data-testid="order-action-approve" (click)="confirmAction('send_accepted_order')" [disabled]="isApproveBlocked()" [matTooltip]="approveBlockedTooltip()" matTooltipClass="product-status-tooltip approve-blocked-tooltip" *appHasPermission="{ module: 'order', action: 'approve' }">
                    <img [src]="isApproveBlocked() ? 'assets/icones/creation-order-Disabled.svg' : 'assets/icones/check_icon.svg'" alt="">
                    <span> {{"quotations_and_orders.approve_order" | translate }}</span>
                </button>
            </ng-container>

            <!-- Requested actions (send, reject) -->
            <ng-container *ngIf="quotation!.status === 'requested' && !isQuotationArchived(quotation)">
                <div class="menu_btn" *ngIf="canDeleteOrder || (hasEnrichableCodes && canCreateKbReference)">
                    <button class="secondary_btns" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder" data-testid="order-action-duplicate" (click)="confirmAction('duplicate_order')">
                          <img src="assets/icones/copy.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.duplicate' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowArchiveAction(quotation)" data-testid="order-action-archive" (click)="confirmAction('archive_order')">
                          <img src="assets/icones/archive.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.archive' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowDeleteAction(quotation)" data-testid="order-action-delete" (click)="confirmAction('delete_order')">
                          <img src="assets/icones/cancel_icon.svg" alt="">
                          <span>{{"common.delete_order"|translate}}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="hasEnrichableCodes && canCreateKbReference" (click)="openEnrichFromMenu()">
                          <img src="assets/icones/ai-volta-icon.svg" alt="" width="24" height="24" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.enrich_external_references.enrich_action' | translate }}</span>
                        </button>
                      </mat-menu>
                </div>
                <!-- Send Button -->
                <button class="btn btn-secondary" data-testid="order-action-send" (click)="confirmAction(quotation!.status)" *appHasPermission="{ module: 'order', action: 'edit' }">
                    <img class="btn-icon" src="assets/icones/send.svg" alt="">
                    <span>{{ 'quotations_and_orders.send_quote' | translate }}</span>
                </button>
                <button class="btn btn-primary" data-testid="order-action-approve" (click)="confirmAction('send_accepted_order')" [disabled]="isApproveBlocked()" [matTooltip]="approveBlockedTooltip()" matTooltipClass="product-status-tooltip approve-blocked-tooltip" *appHasPermission="{ module: 'order', action: 'approve' }">
                    <img src="assets/icones/check_icon.svg" alt="">
                    <span> {{"quotations_and_orders.approve_order" | translate }}</span>
                </button>
            </ng-container>

            <!-- Sent actions (resend, accept) -->
            <ng-container *ngIf="quotation!.status === 'sent' && !isQuotationArchived(quotation)">
                <!-- Resend Button -->
                <button *ngIf="quotation.channel !== 'Agent portal'" class="btn btn-secondary" (click)="resendQuote()">
                    <img class="btn-icon" src="assets/icones/send.svg" alt="">
                    <span>{{ 'quotations_and_orders.resend' | translate }}</span>
                </button>
                <!-- Accept Button -->
                <button class="btn btn-primary" data-testid="order-action-send" (click)="confirmAction(quotation!.status)">
                    <img class="btn-icon" src="assets/icones/orders.svg" alt="">
                    <span >{{ 'quotations_and_orders.accept_and_sign' | translate }}</span>
                </button>
            </ng-container>

            <!-- to_be_validated and pending_inventory actions (cancel, approve) -->
            <ng-container *ngIf="['to_be_validated', 'pending_inventory'].includes(quotation!.status) && !isQuotationArchived(quotation)">
                <div class="menu_btn" *ngIf="canDeleteOrder || (hasEnrichableCodes && canCreateKbReference)">
                    <button class="secondary_btns" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon style="color: #9d9a9a;">more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder" data-testid="order-action-duplicate" (click)="confirmAction('duplicate_order')">
                          <img src="assets/icones/copy.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.duplicate' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowArchiveAction(quotation)" data-testid="order-action-archive" (click)="confirmAction('archive_order')">
                          <img src="assets/icones/archive.svg" alt="" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.actions.archive' | translate }}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="canDeleteOrder && canShowDeleteAction(quotation)" data-testid="order-action-delete" (click)="confirmAction('delete_order')">
                          <img src="assets/icones/cancel_icon.svg" alt="">
                          <span>{{"common.delete_order"|translate}}</span>
                        </button>
                        <button mat-menu-item class="menu_item" *ngIf="hasEnrichableCodes && canCreateKbReference" (click)="openEnrichFromMenu()">
                          <img src="assets/icones/ai-volta-icon.svg" alt="" width="24" height="24" onerror="this.style.display='none'">
                          <span>{{ 'quotations_and_orders.enrich_external_references.enrich_action' | translate }}</span>
                        </button>
                      </mat-menu>
                </div>
                <!-- Cancel Button -->
                <button class="btn btn-danger" data-testid="order-action-cancel" (click)="confirmAction('cancel')" *appHasPermission="{ module: 'order', action: 'edit' }">
                    <img class="btn-icon" src="assets/icones/cancel_icon.svg" alt="">
                    <span >{{ 'common.cancel' | translate }}</span>
                </button>
                <!-- Resend Button -->
                <!-- <button class="btn btn-secondary" (click)="resendQuote()">
                    <img class="btn-icon" src="assets/icones/send.svg" alt="">
                    <span>{{ 'quotations_and_orders.resend' | translate }}</span>
                </button> -->
                <!-- Approve Button -->
                <button class="action-button approve-button" [ngClass]="quotation && !isExpired(quotation.validity_date) ? 'approve-button' : 'btn-expired'" [disabled]="(quotation && isExpired(quotation.validity_date)) || isApproveBlocked()" [matTooltip]="approveBlockedTooltip()" matTooltipClass="product-status-tooltip approve-blocked-tooltip" data-testid="order-action-approve" (click)="isNavaPress ? checkQuotationAvailability() : confirmAction('to_be_validated')" *appHasPermission="{ module: 'order', action: 'approve' }">
                    <img src="assets/icones/check_icon.svg" alt="">
                    <span >{{"quotations_and_orders.approve_order" | translate}}</span>
                </button>
            </ng-container>

        </ng-container>
        <ng-container class="header-actions-comp" *ngIf="['products', 'products-from-catalog', 'products-from-all-products'].includes(currentComponent)">
            <ng-container *ngIf="currentComponent === 'products'">
                <!-- update quote -->
                <button class="btn btn-primary" (click)="UpdateOrder()" [disabled]="!isFormValid">
                    <img class="btn-icon" src="assets/icones/check_icon.svg" alt="">
                    <span>{{ "quotations_and_orders.update_order" | translate }}</span>
                </button>
            </ng-container>
            <ng-container *ngIf="currentComponent === 'products-from-catalog' || currentComponent === 'products-from-all-products'">
                <!-- products from catalog -->
                <button class="btn btn-primary" (click)="goTo('products')">
                    <img class="btn-icon" src="assets/icones/plus_icon.svg" alt="">
                    <span >{{ "quotations_and_orders.add_selection_to_order" | translate }}</span>
                </button>
            </ng-container>
        </ng-container>
        <ng-container class="header-actions-comp" *ngIf="currentComponent === 'source-content'">
            <button class="btn btn-primary" (click)="UpdateEmailOrder()" [disabled]="intent === initialIntent">
                <img class="btn-icon" src="assets/icones/check_icon.svg" alt="">
                <span>Update</span>
            </button>
        </ng-container>
    </div>
</div>

<div class="details-quote" *ngIf="currentComponent === 'details'">
    <div class="order-details-content" *ngIf="(quotation$ | async) as quotation">
        <!-- Left Section: Product List -->
         <div class="product-list-section-container" [class.prompt-to-order-loading-border]="(isPromptToOrderLoading$ | async) === true">
            <div class="product-list-section">
                <div class="product-list-header">
                    <span class="products-title">{{"quotations_and_orders.product" | translate}}</span>
                    <div class="product-summary">
                        <span class="summary-item">{{quotation.total_order_lines}} {{(quotation.total_order_lines === 1 ? "quotations_and_orders.order_line" : "quotations_and_orders.order_lines") | translate}}</span>
                        <span class="summary-item">{{quotation.total_skus}} {{(quotation.total_skus === 1 ? "quotations_and_orders.sku" : "quotations_and_orders.skus") | translate}}</span>
                        <span class="summary-separator"></span>
                        <span class="summary-total-price" [class.no-price]="quotation.all_lines_no_price">
                            <ng-container *ngIf="quotation.all_lines_no_price; else totalPriceValue">{{ 'quotations_and_orders.price_source_none' | translate }}</ng-container>
                            <ng-template #totalPriceValue>
                                {{ quotation.priced_lines_total | number:'1.2-2' }} {{ currency?.symbol }}
                                <span *ngIf="featureFlags.loyaltyEnabled && (quotation$ | async)?.old_total_amount && (quotation$ | async)?.amount_total !== (quotation$ | async)?.old_total_amount" class="original-price"> {{ (quotation$ | async)?.old_total_amount | number:'1.2-2' }} {{ currency?.symbol }}</span>
                            </ng-template>
                        </span>
                        <app-gift-tooltip *ngIf="featureFlags.loyaltyEnabled && ((orderDeals$ | async)?.best_deal?.length || (quotation$ | async)?.best_deal)"
                         [gifts]="((orderDeals$ | async)?.best_deal || (quotation$ | async)?.best_deal)!"
                         [parameters]="{ amount: getProductsLineTotalAmount() || null, quantity: quotation.total_qty || null }"
                         ></app-gift-tooltip>
                        <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                            <button class="view-edit-button" (click)="editQuote()" *ngIf="['draft', 'requested', 'sent', 'to_be_validated', 'pending_inventory'].includes(quotation!.status) && !isAiOrder()"
                                    [disabled]="(quotation.products?.length || 0) === 0"
                                >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 3H21M21 3V9M21 3L14 10M9 21H3M3 21V15M3 21L10 14" stroke="#6449DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                <span>{{"quotations_and_orders.view_and_edit" | translate}}</span>
                            </button>
                            <button *ngIf="isAiOrder()" class="view-edit-button" (click)="openSideBySideDialog()">
                                <ui-svg-icon svgIcon="panel_icon" size="medium"></ui-svg-icon>
                                <span>{{(viewMode ? "common.view" : "common.edit") | translate}}</span>
                            </button>
                        </ng-container>
                        <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                            <div class="bulk-actions" *ngIf="canBulkSelectLines && selectedLinesCount > 0">
                                <span class="bulk-actions-count">{{ 'quotations_and_orders.side_by_side_panel.items_selected' | translate: { count: selectedLinesCount } }}</span>
                                <ui-button type="danger" icon="trash-cc" (click)="removeSelectedLines()"
                                    [matTooltip]="'quotations_and_orders.side_by_side_panel.remove_selected_tooltip' | translate" matTooltipClass="product-status-tooltip"></ui-button>
                            </div>
                        </ng-container>
                        <ui-table-column-settings
                            triggerIcon="sliders-horizontal"
                            [columns]="pickerColumns"
                            (columnsChange)="onColumnsChange($event)"
                        ></ui-table-column-settings>

                    </div>
                </div>
                 <ng-container *ngIf="(quotation$ | async)?.ai_details as ai_details">
                    <!-- <div class="panner-container product-mismatch" *ngIf="unmatchedProducts.length > 0">
                        <ui-svg-icon svgIcon="alert_icon" size="large"></ui-svg-icon>
                        <div class="panner-content">
                            <span *ngIf="unmatchedProducts.length === 1">
                                {{"quotations_and_orders.source_content.one_product_not_found" | translate}}
                                {{"quotations_and_orders.source_content.requires_manual_matching" | translate}} :
                                {{unmatchedProducts[0].name}}
                            </span>
                            <span *ngIf="unmatchedProducts.length > 1">
                                {{unmatchedProducts.length}}
                                {{"quotations_and_orders.source_content.multiple_products_not_found" | translate}}
                                {{"quotations_and_orders.source_content.requires_manual_matching" | translate}} :
                                <ul class="product-list-unmatched">
                                    <li *ngFor="let unmatched of unmatchedProducts.slice(0, 3)">
                                        {{unmatched.name}}
                                    </li>
                                    <li *ngIf="unmatchedProducts.length > 3">
                                        ... {{ unmatchedProducts.length - 3 }} more
                                    </li>
                                </ul>
                            </span>
                        </div>
                        <button class="view-edit-button" (click)="openMatchingMissingAiQuoteProducts()">
                            <img src="assets/icones/arrow-outward.svg" alt="">
                        </button>
                    </div> -->
                 </ng-container>
               <!-- Force-send conflict panel: visible only on to_be_validated orders with stored conflict context -->
                <div class="force-send-conflict-panel"
                     *ngIf="!conflictPanelDismissed && (quotation$ | async)?.force_send && (quotation$ | async)?.status === 'to_be_validated' && ((quotation$ | async)?.erp_missing_inventory?.length || (quotation$ | async)?.erp_missing_products?.length)">
                  <div class="conflict-panel-header">
                    <img src="assets/icones/mid-info-icon.svg" alt="">
                    <span class="conflict-panel-title">{{ 'quotations_and_orders.force_send_conflict_panel.title' | translate }}</span>
                    <button class="conflict-dismiss-btn" (click)="dismissConflictPanel()" aria-label="Dismiss">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                  <p class="conflict-panel-desc">{{ 'quotations_and_orders.force_send_conflict_panel.description' | translate }}</p>

                  <!-- Insufficient inventory items -->
                  <div class="conflict-products-list" *ngIf="(quotation$ | async)?.erp_missing_inventory?.length">
                    <div class="conflict-products-list-label">{{ 'quotations_and_orders.force_send_conflict_panel.insufficient_stock' | translate }}</div>
                    <div class="conflict-product-row" *ngFor="let item of (quotation$ | async)?.erp_missing_inventory">
                      <img class="conflict-product-img" [src]="item.image ? baseUrl + item.image : placeholder" alt="">
                      <div class="conflict-product-info">
                        <span class="conflict-product-name">{{ item.product_name }}</span>
                        <span class="conflict-product-sku">{{ item | productCode }}</span>
                      </div>
                      <div class="conflict-qty-group">
                        <div class="conflict-qty-item">
                          <span class="conflict-qty-label">{{ 'quotations_and_orders.status_dialog.product_details.ordered' | translate }}</span>
                          <span class="conflict-qty-value">{{ item.order_qty }}</span>
                        </div>
                        <div class="conflict-qty-item erp-qty">
                          <span class="conflict-qty-label">{{ 'quotations_and_orders.status_dialog.product_details.available' | translate }}</span>
                          <span class="conflict-qty-value">{{ item.erp_qty }}</span>
                        </div>
                        <div class="conflict-date-cols" *ngIf="item.erp_delivery_date">
                          <div class="conflict-qty-item">
                            <span class="conflict-qty-label">{{ 'quotations_and_orders.force_send_conflict_panel.buyer_date' | translate }}</span>
                            <span class="conflict-qty-value">{{ shippingDate ? (shippingDate | adaptToUserUtcOffset | date: DATE_FORMAT) : '--' }}</span>
                          </div>
                          <span class="conflict-date-arrow">→</span>
                          <div class="conflict-qty-item">
                            <span class="conflict-qty-label">{{ 'quotations_and_orders.force_send_conflict_panel.erp_proposed_date' | translate }}</span>
                            <span class="conflict-qty-value erp-date-val">{{ item.erp_delivery_date | date: DATE_FORMAT }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Missing in ERP items -->
                  <div class="conflict-products-list" *ngIf="(quotation$ | async)?.erp_missing_products?.length">
                    <div class="conflict-products-list-label">{{ 'quotations_and_orders.force_send_conflict_panel.missing_in_erp' | translate }}</div>
                    <div class="conflict-product-row" *ngFor="let item of (quotation$ | async)?.erp_missing_products">
                      <img class="conflict-product-img" [src]="item.image ? baseUrl + item.image : placeholder" alt="">
                      <div class="conflict-product-info">
                        <span class="conflict-product-name">{{ item.product_name }}</span>
                        <span class="conflict-product-sku">{{ item | productCode }}</span>
                      </div>
                      <span class="missing-erp-badge">{{ 'quotations_and_orders.force_send_conflict_panel.not_in_erp' | translate }}</span>
                    </div>
                  </div>
                </div>

               <div class="product-table-container" *ngIf="(isPromptToOrderLoading$ | async) !== true">
                            <div class="no-data-container" *ngIf="(quotation.products?.length || 0) === 0 && (unmatchedProducts.length === 0) && quotation?.channel !== 'email' && !isAddProductMode">
                                <img src="assets/icones/Backoffice-Portal-Design.svg" alt="cart" />
                                <span class="no-data-msg">
                                    {{ 'quotations_and_orders.add_products_to_order' | translate }}
                                </span>
                                <span class="no-data-desc">
                                    {{ 'quotations_and_orders.select_products_from_catalogs' | translate }}
                                </span>
                                <ui-button
                                    type="secondary"
                                    [label]="'quotations_and_orders.explore_catalogs' | translate"
                                    (click)="setPage('explore_catalog')"
                                ></ui-button>
                                <ui-button
                                    *appHasPermission="{ module: 'order', action: 'edit' }"
                                    type="secondary"
                                    [label]="'quotations_and_orders.select_products' | translate"
                                    (click)="startAddProduct()"
                                ></ui-button>
                                <div class="ask-volta-container">
                                    <h1>{{"common.or"|translate}}</h1>
                                    <span>
                                        {{"quotations_and_orders.prompt.bring_in_data"|translate}}
                                    </span>
                                    <button class="action-btn tertiary-btn" (click)="promptAiVolta()">
                                        <span class="icon">
                                            <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                                        </span>
                                        <span>{{"common.ask_volta"|translate}}</span>
                                    </button>
                                </div>
                            </div>
                    <div class="product-scrolabel-table-container"
                         [class]="!viewMode ? (isAddProductMode ? 'products-viewport-add-product' : 'products-viewport') : ''"
                         #productsScrollContainer
                         (scroll)="onProductsScroll($event)">
                    <table class="product-table">
                        <thead *ngIf="((quotation.products?.length || 0) > 0) || unmatchedProducts.length > 0">
                            <tr>
                                <th scope="col" class="col-select" *ngIf="canBulkSelectLines">
                                    <mat-checkbox class="zero-spacing-checkbox" [checked]="isAllLinesSelected()" [indeterminate]="isPartialLinesSelected()" (change)="toggleAllLines($event.checked)"></mat-checkbox>
                                </th>
                                <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                                <th *ngSwitchCase="'image'" scope="col" class="col-img">{{ columns.image.label | translate }}</th>
                                <th *ngSwitchCase="'product'" scope="col" class="col-product sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.product.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('product') === 'asc'" (click)="setSortColumnDirection('product', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('product') === 'desc'" (click)="setSortColumnDirection('product', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'sku'" scope="col" class="col-sku sortable-column">
                                  <div class="sort-header-content">
                                    <!-- Header follows the tenant's primary identifier, not the row-level
                                         resolution: a single SKU-fallback row must not rename the column (WB-7419). -->
                                    {{ productCode.primaryLabelKey | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('sku') === 'asc'" (click)="setSortColumnDirection('sku', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('sku') === 'desc'" (click)="setSortColumnDirection('sku', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'notes'" scope="col" class="col-notes">{{ columns.notes.label | translate }}</th>
                                <th *ngSwitchCase="'brand'" scope="col" class="col-brand sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.brand.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('brand') === 'asc'" (click)="setSortColumnDirection('brand', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('brand') === 'desc'" (click)="setSortColumnDirection('brand', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'quantity'" scope="col" class="col-qty sortable-column">
                                  <div class="sort-header-content">
                                    <span class="col-header-with-info">
                                      {{ columns.quantity.label | translate }}
                                      <ui-svg-icon class="header-info-icon" svgIcon="info" size="small"
                                        [matTooltip]="'quotations_and_orders.order_line_columns.quantity_tooltip' | translate"
                                        matTooltipClass="qty-header-tooltip"
                                        (click)="$event.stopPropagation()"></ui-svg-icon>
                                    </span>
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('quantity') === 'asc'" (click)="setSortColumnDirection('quantity', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('quantity') === 'desc'" (click)="setSortColumnDirection('quantity', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'quantity_preferred_selling_unit'" scope="col" class="col-qty-preferred-selling-unit">
                                  <div class="col-header-two-line">
                                    <span class="header-line header-line-primary col-header-with-info">
                                      {{ columns.quantity_preferred_selling_unit.label | translate }}
                                      <ui-svg-icon class="header-info-icon" svgIcon="info" size="small"
                                        [matTooltip]="'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit_tooltip' | translate"
                                        matTooltipClass="qty-header-tooltip"
                                        (click)="$event.stopPropagation()"></ui-svg-icon>
                                    </span>
                                    <span class="header-line header-line-secondary">{{ 'quotations_and_orders.order_line_columns.quantity_preferred_selling_unit_line2' | translate }}</span>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'quantity_units'" scope="col" class="col-qty-units">
                                  <div class="col-header-two-line">
                                    <span class="header-line header-line-primary col-header-with-info">
                                      {{ columns.quantity_units.label | translate }}
                                      <ui-svg-icon class="header-info-icon" svgIcon="info" size="small"
                                        [matTooltip]="'quotations_and_orders.order_line_columns.quantity_units_tooltip' | translate"
                                        matTooltipClass="qty-header-tooltip"
                                        (click)="$event.stopPropagation()"></ui-svg-icon>
                                    </span>
                                    <span class="header-line header-line-secondary">{{ 'quotations_and_orders.order_line_columns.quantity_units_line2' | translate }}</span>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'msrp'" scope="col" class="col-msrp sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.msrp.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('msrp') === 'asc'" (click)="setSortColumnDirection('msrp', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('msrp') === 'desc'" (click)="setSortColumnDirection('msrp', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'cost'" scope="col" class="col-cost sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.cost.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('cost') === 'asc'" (click)="setSortColumnDirection('cost', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('cost') === 'desc'" (click)="setSortColumnDirection('cost', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'discount'" scope="col" class="col-discount">{{ columns.discount.label | translate }}</th>
                                <th *ngSwitchCase="'unit_price'" scope="col" class="col-unit-price sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.unit_price.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('unit_price') === 'asc'" (click)="setSortColumnDirection('unit_price', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('unit_price') === 'desc'" (click)="setSortColumnDirection('unit_price', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'total_amount'" scope="col" class="col-total sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.total_amount.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('total_amount') === 'asc'" (click)="setSortColumnDirection('total_amount', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('total_amount') === 'desc'" (click)="setSortColumnDirection('total_amount', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'profit_margin'" scope="col" class="col-profit sortable-column">
                                  <div class="sort-header-content">
                                    {{ columns.profit_margin.label | translate }}
                                    <div class="sort-actions">
                                      <span class="arrow-up" [class.active]="getSortDirection('profit_margin') === 'asc'" (click)="setSortColumnDirection('profit_margin', 'asc'); $event.stopPropagation()"></span>
                                      <span class="arrow-down" [class.active]="getSortDirection('profit_margin') === 'desc'" (click)="setSortColumnDirection('profit_margin', 'desc'); $event.stopPropagation()"></span>
                                    </div>
                                  </div>
                                </th>
                                <th *ngSwitchCase="'delivery_date'" scope="col" class="col-delivery">{{ columns.delivery_date.label | translate }}</th>
                                <th *ngSwitchCase="'stock'" scope="col" class="col-stock">{{ columns.stock.label | translate }}</th>
                                <!-- Product custom field columns (WB-7619) — labels come resolved from the definition. -->
                                <ng-container *ngSwitchDefault>
                                    <th *ngIf="isCustomFieldColumn(key)" scope="col" class="col-custom-field">{{ customFieldColumnLabel(key) }}</th>
                                </ng-container>
                                </ng-container>
                                <th *ngIf="(quotation$ | async)?.channel == 'Agent portal'" scope="col" class="col-total">{{"quotations_and_orders.commission"| translate}}</th>
                            </tr>
                        </thead>
                        <tbody class="scrollable_body" #productsTbody>
                            <ng-container *ngFor="let item of combinedLines; trackBy: trackByProductFn">
                        <ng-container *ngIf="item._isUnmatched">
                            <tr class="unmatched_line" (click)="openMatchSingleOrderLineProduct(item, $event, true)">
                                <td class="col-select" *ngIf="canBulkSelectLines" (click)="$event.stopPropagation()">
                                    <mat-checkbox [checked]="isLineSelected(item)" [disabled]="!isLineSelectable(item)" (change)="toggleLine(item, $event.checked)"></mat-checkbox>
                                </td>
                                <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                                <td *ngSwitchCase="'image'" class="col-img">
                                    <div class="unmatched_img">
                                        <ui-svg-icon svgIcon="alert_icon" size="large"></ui-svg-icon>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'product'" class="col-product product-name-column">
                                    <div class="product-info">
                                        <div class="product-name">{{item.ai_extracted_name}}</div>
                                    </div>
                                    <div class="product-icons">
                                        <ui-svg-icon class="unmatched-icon" svgIcon="unmatched-icon" style="cursor: pointer" (click)="!viewMode && openMatchSingleOrderLineProduct(item, $event, true); $event.stopPropagation()" size="medium" [matTooltip]="'Unmatched product'" matTooltipClass="product-status-tooltip"
                                            [appFtueAnchor]="ftueAnchorFor(item)"></ui-svg-icon>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'sku'" class="col-sku">{{item.description || '--'}}</td>
                                <td *ngSwitchCase="'notes'" class="col-notes">--</td>
                                <td *ngSwitchCase="'brand'" class="col-brand">--</td>
                                <td *ngSwitchCase="'quantity'" class="col-qty qty-column-unmatched">
                                    <div class="product-info">
                                        <div class="product-name">
                                            {{item.quantity}}
                                        </div>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'quantity_preferred_selling_unit'" class="col-qty-preferred-selling-unit">--</td>
                                <td *ngSwitchCase="'quantity_units'" class="col-qty-units">--</td>
                                <td *ngSwitchCase="'msrp'" class="col-msrp">--</td>
                                <td *ngSwitchCase="'cost'" class="col-cost">--</td>
                                <td *ngSwitchCase="'discount'" class="col-discount">--</td>
                                <td *ngSwitchCase="'unit_price'" class="col-unit-price">--</td>
                                <td *ngSwitchCase="'total_amount'" class="col-total">--</td>
                                <td *ngSwitchCase="'profit_margin'" class="col-profit">
                                    <span class="profit-amount">--</span>
                                    <span class="profit-markup">--</span>
                                </td>
                                <td *ngSwitchCase="'delivery_date'" class="col-delivery">{{getFormattedDeliveryDate(item)}}</td>
                                <!-- Unmatched lines have no product, so no stock (WB-7903). -->
                                <td *ngSwitchCase="'stock'" class="col-stock">--</td>
                                <!-- Unmatched lines have no product, so no custom field values (WB-7619). -->
                                <ng-container *ngSwitchDefault>
                                    <td *ngIf="isCustomFieldColumn(key)" class="col-custom-field">--</td>
                                </ng-container>
                                </ng-container>
                                <td *ngIf="(quotation$ | async)?.channel == 'Agent portal'" class="col-total">--</td>
                                <td *ngIf="(quotation$ | async)?.channel == 'Agent portal'" class="col-total">--</td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="!item._isUnmatched">
                                <tr (click)="item.duplicated && !item.is_buy_x_get_y_line ? openDuplicatedProductHandler(item) : showStockFulfillment(item)">
                                    <td class="col-select" *ngIf="canBulkSelectLines" (click)="$event.stopPropagation()">
                                        <mat-checkbox [checked]="isLineSelected(item)" [disabled]="!isLineSelectable(item)" (change)="toggleLine(item, $event.checked)"></mat-checkbox>
                                    </td>
                                    <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                                    <td *ngSwitchCase="'image'" class="col-img">
                                        <img [class]="!item.image ? 'no-image' : ''" [src]="item.image ? baseUrl + item.image + '?thumbnail=1' : placeholder" alt="">
                                    </td>
                                    <td *ngSwitchCase="'product'" class="col-product product-name-column">
                                        <div class="product-info">
                                            <div class="product-name">{{item.name}}</div>
                                            <!-- <div
                                                *ngIf="isAiOrder() && !item.matched && !item.added_manually; else skuOnlyTpl"
                                                tooltip=""
                                                [tooltipTemplate]="aiVoltaTooltipTpl"
                                                [offsetLeft]="250"
                                                [offsetTop]="-10"
                                                [maxWidth]="'500px'"
                                                (click)="$event.stopPropagation()"
                                            >
                                                <div class="product-state">
                                                    <div *ngIf="item.has_alternatives" class="tag review-tag">{{"quotations_and_orders.matching_missing_ai_quote_products.review" | translate}}</div>
                                                </div>
                                                <ng-template #aiVoltaTooltipTpl>
                                                    <div class="ai-volta-tooltip" (click)="$event.stopPropagation()">
                                                        <span class="ai-volta-tooltip-text">{{ (item.matched ? "quotations_and_orders.manually_matched_tooltip" : "quotations_and_orders.ai_matched_tooltip") | translate }}</span>
                                                        <div class="change-product-btn-container" (click)="openMatchSingleOrderLineProduct(item, $event)">
                                                            <ui-svg-icon svgIcon="switch-icon" size="large"></ui-svg-icon>
                                                            <button class="change-product-btn" (click)="openMatchSingleOrderLineProduct(item, $event)">
                                                                {{"common.change_product"|translate}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <ng-template #skuOnlyTpl>
                                                <div *ngIf="item.matched || item.added_manually" class="tag matched-tag">{{"quotations_and_orders.matching_missing_ai_quote_products.manual" | translate}}</div>
                                            </ng-template> -->
                                            <!-- <div *ngIf="quotation.channel === 'email' && item.matched" class="tag matched-tag">{{"quotations_and_orders.matching_missing_ai_quote_products.manually_matched" | translate}}</div> -->
                                        </div>
                                        <div class="product-icons" [class.product-icons-view-mode]="viewMode">
                                            <ui-svg-icon class="status-icon" [class]="getProductStatusIcon(item)" [class.status-icon--actionable]="!viewMode && !item.added_manually" *ngIf="isAiOrder()"
                                                (click)="!viewMode && !item.added_manually ? openMatchSingleOrderLineProduct(item, $event) : null; $event.stopPropagation()"
                                                [svgIcon]="getProductStatusIcon(item)"
                                                [style.cursor]="(!viewMode && !item.added_manually) ? 'pointer' : 'default'"
                                                [matTooltip]="getProductMatchTooltip(item)"
                                                matTooltipClass="product-status-tooltip"
                                                [appFtueAnchor]="ftueAnchorFor(item)"
                                                size="medium">
                                            </ui-svg-icon>
                                            <ui-svg-icon class="alert-product-icon" *ngIf="hasAlerts(item)" (click)="!viewMode ? handleAlerts(item) : null; $event.stopPropagation()" svgIcon="draft-alert" size="medium"
                                                [style.cursor]="viewMode ? 'default' : 'pointer'"
                                                [matTooltip]="(getAlertsForLine(item).length || 0) + ' Alerts'"
                                                matTooltipClass="product-status-tooltip"></ui-svg-icon>
                                        </div>
                                    </td>
                                <td *ngSwitchCase="'sku'" class="col-sku">
                                    <ui-copyable [value]="item | productCode:''" [label]="productCode.labelKey(item) | translate">
                                        <span [class.sku--matched]="isSkuMatchHighlight(item)">{{ item | productCode }}</span>
                                    </ui-copyable>
                                    <span *ngIf="getInlineMatchCode(item)" class="match-code-inline">({{ getInlineMatchCode(item) }})</span>
                                    <ng-container *ngIf="getSemanticCodesForDisplay(item) as semanticCodes">
                                        <span class="semantic-code" *ngIf="semanticCodes.length">
                                            <ui-svg-icon svgIcon="ai-volta-icon" size="xsmall"></ui-svg-icon>
                                            <span class="semantic-code__value">{{ semanticCodes.join(', ') }}</span>
                                        </span>
                                    </ng-container>
                                </td>
                                <td *ngSwitchCase="'notes'" class="col-notes" (click)="$event.stopPropagation()">
                                    <div class="notes-cell">
                                        <!-- WITH NOTES: filled icon + centered interactive tooltip (note text + Edit) -->
                                        <ui-svg-icon
                                            *ngIf="item.notes; else addNoteBtn"
                                            class="notes-icon has-notes"
                                            tooltip=""
                                            [tooltipTemplate]="notesTooltip"
                                            [center]="true"
                                            [maxWidth]="'320px'"
                                            svgIcon="comment"
                                            size="medium"
                                            (click)="openLineNotesDialog(item)">
                                        </ui-svg-icon>
                                        <ng-template #notesTooltip>
                                            <div class="notes-tooltip">
                                                <div class="notes-tooltip-header">
                                                    <span class="notes-tooltip-title">{{ 'quotations_and_orders.line_notes.column' | translate }}</span>
                                                </div>
                                                <div class="notes-tooltip-body">{{ item.notes }}</div>
                                                <div class="notes-tooltip-actions">
                                                    <button class="notes-tooltip-edit" (click)="$event.stopPropagation(); openLineNotesDialog(item)">
                                                        <ui-svg-icon svgIcon="inline-edit" size="small" *ngIf="canEdit"></ui-svg-icon>
                                                        {{ (canEdit ? 'quotations_and_orders.line_notes.edit' : 'common.view') | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-template>

                                        <!-- NO NOTES: comment icon that becomes a + button on hover, small actionless label -->
                                        <ng-template #addNoteBtn>
                                            <button
                                                *ngIf="canEdit"
                                                type="button"
                                                class="notes-add-btn"
                                                tooltip=""
                                                [tooltipTemplate]="addNoteTooltip"
                                                [center]="true"
                                                (click)="openLineNotesDialog(item)">
                                                <ui-svg-icon class="notes-icon notes-icon-default" svgIcon="comment" size="medium"></ui-svg-icon>
                                                <ui-svg-icon class="notes-icon notes-icon-hover" svgIcon="plus-cc" size="medium"></ui-svg-icon>
                                            </button>
                                            <ng-template #addNoteTooltip>
                                                <div class="notes-tooltip-mini">{{ 'quotations_and_orders.line_notes.add' | translate }}</div>
                                            </ng-template>
                                        </ng-template>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'brand'" class="col-brand">{{item.brand_name || '--'}}</td>
                                <td *ngSwitchCase="'quantity'" class="col-qty">
                                    <div class="qty-inline-edit-container" (click)="$event.stopPropagation()">
                                        <!-- DISPLAY MODE -->
                                        <div class="qty-display"
                                             *ngIf="!isEditingQuantity(item)"
                                             (click)="!viewMode && item.handling_units && item.handling_units.length > 0 ? startEditQuantity(item) : null"
                                             [class.qty-display-clickable]="!viewMode && item.handling_units && item.handling_units.length > 0">
                                            <ng-container *ngIf="item.quantity_handling_unit !== null && item.quantity_handling_unit !== undefined && item.handling_units && item.handling_units.length > 0; else noHUDisplay">
                                                <span class="qty-value">{{ item.quantity_handling_unit }}</span>
                                                <span class="hu-tag" *ngIf="getSelectedHandlingUnit(item.handling_units) as hu">
                                                    {{ hu.name }}
                                                </span>
                                            </ng-container>
                                            <ng-template #noHUDisplay>
                                                <span class="qty-value">{{ item.quantity }} units</span>
                                            </ng-template>
                                            <ui-svg-icon
                                                *ngIf="item.handling_units && item.handling_units.length > 0"
                                                tooltip=""
                                                [tooltipTemplate]="qtyInfoTooltip"
                                                svgIcon="info"
                                                size="medium"
                                                (click)="$event.stopPropagation()">
                                            </ui-svg-icon>
                                            <ui-svg-icon *ngIf="!viewMode" class="qty-inline-edit-icon" (click)="cancelEditQuantity()" svgIcon="inline-edit" size="medium"></ui-svg-icon>
                                        </div>

                                        <!-- EDIT MODE -->
                                        <div class="qty-edit standard-input" *ngIf="!viewMode && isEditingQuantity(item)">
                                            <input
                                                type="number"
                                                class="qty-edit-input"
                                                min="0"
                                                step="any"
                                                [value]="editQuantityHU"
                                                (input)="onEditQuantityInput($event)"
                                                (keyup.enter)="submitEditQuantity(item)"
                                                (keyup.escape)="cancelEditQuantity()"
                                            >
                                            <mat-select
                                                *ngIf="item.handling_units && item.handling_units.length > 0"
                                                class="hu-edit-select"
                                                panelClass="hu-select-panel"
                                                [value]="editHandlingUnitId"
                                                (selectionChange)="onEditHandlingUnitChange($event, item)"
                                                disableRipple
                                            >
                                                <mat-select-trigger>
                                                    <div class="hu-option-row">
                                                        <span class="hu-option-name" *ngIf="getHandlingUnitById(item.handling_units, editHandlingUnitId) as hu">{{ hu.name }}</span>
                                                    </div>
                                                </mat-select-trigger>
                                                <mat-option *ngFor="let hu of item.handling_units" [value]="hu.id">
                                                    <div class="hu-option-row">
                                                        <span class="hu-option-name">{{ hu.name }}</span>
                                                        <span class="hu-option-quantity">{{ hu.quantity }} units</span>
                                                    </div>
                                                </mat-option>
                                                <mat-option *appHasPermission="{ module: 'product', action: 'edit' }" class="hu-create-option" [value]="HU_CREATE_SENTINEL">
                                                    <ui-svg-icon svgIcon="plus-cc" size="small"></ui-svg-icon>
                                                    <span class="hu-create-label">{{ 'quotations_and_orders.side_by_side_panel.create_selling_unit' | translate }}</span>
                                                </mat-option>
                                            </mat-select>
                                            <ui-svg-icon class="qty-edit-icon" (click)="submitEditQuantity(item)" svgIcon="check-cc" size="medium"></ui-svg-icon>
                                            <ui-svg-icon
                                                *ngIf="item.handling_units && item.handling_units.length > 0"
                                                tooltip=""
                                                [tooltipTemplate]="qtyInfoTooltip"
                                                svgIcon="info"
                                                size="medium"
                                                (click)="$event.stopPropagation()">
                                            </ui-svg-icon>
                                        </div>

                                        <!-- Tooltip template -->
                                        <ng-template #qtyInfoTooltip>
                                            <app-qty-details-tooltip
                                                [item]="item"
                                                [selectedHu]="getSelectedHandlingUnit(item.handling_units)">
                                            </app-qty-details-tooltip>
                                        </ng-template>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'quantity_preferred_selling_unit'" class="col-qty-preferred-selling-unit">
                                    <ng-container *ngIf="item.quantity_preferred_selling_unit !== null && item.quantity_preferred_selling_unit !== undefined; else noPreferredSellingUnit">
                                        {{ item.quantity_preferred_selling_unit }} {{ item.quantity_preferred_selling_unit_name }}
                                    </ng-container>
                                    <ng-template #noPreferredSellingUnit>--</ng-template>
                                </td>
                                <td *ngSwitchCase="'quantity_units'" class="col-qty-units">
                                    {{ item.quantity }} {{ 'quotations_and_orders.side_by_side_panel.units_suffix' | translate }}
                                </td>
                                <td *ngSwitchCase="'msrp'" class="col-msrp">
                                    <div class="price-info" [class.no-price]="item.price_type === 'none'" *ngIf="!item.is_buy_x_get_y_line && !item.is_gift; else giftTag">
                                        {{ item.price_type === 'none' ? ('quotations_and_orders.price_source_none' | translate) : (item.price_unit ? item.price_unit.toFixed(2) + currency?.symbol! : '--') }}
                                            <app-gift-tooltip
                                            *ngIf="featureFlags.loyaltyEnabled && getProductGifts(item).length > 0"
                                            [gifts]="getProductGifts(item)"
                                            [parameters]="{
                                                amount: item.old_total_amount || null,
                                                quantity: item.quantity || null,
                                                total_amount: item.amount_for_deal || null,
                                                total_quantity: item.quantity_for_deal || null
                                            }"
                                            ></app-gift-tooltip>
                                    </div>
                                    <ng-template #giftTag>
                                        <div [style]="{ width: 'fit-content' }" *ngIf="featureFlags.loyaltyEnabled">
                                            <span class="details-badge free-badge">
                                                <img src="assets/icones/gift.svg" alt=""/>
                                                 Gift
                                            </span>
                                        </div>
                                    </ng-template>
                                </td>
                                <td *ngSwitchCase="'cost'" class="col-cost">
                                  <ng-container *ngIf="item.cost !== null && item.cost !== undefined && !item.is_buy_x_get_y_line && !item.is_gift; else noDataCost">
                                    {{ item.cost }}
                                  </ng-container>
                                  <ng-template #noDataCost> -- </ng-template>
                                </td>
                                <td *ngSwitchCase="'discount'" class="col-discount">
                                    <div class="discounts-container" *ngIf="featureFlags.loyaltyEnabled && getProductAppliedDiscounts(item).length > 0 && !item.is_buy_x_get_y_line && !item.is_gift; else noDiscount">
                                        <app-discount-tooltip *ngFor="let gift of getProductAppliedDiscounts(item); trackBy: trackByProductFn" [appliedDiscount]="gift"></app-discount-tooltip>
                                    </div>
                                    <ng-template #noDiscount>
                                        --
                                    </ng-template>
                                </td>

                                <!-- <td *ngIf="(quotation$ | async)?.channel == 'Agent portal' && (quotation$ | async)?.pricelist_max_extra_discount" class="col-total">{{item.extra_discount ? item.extra_discount + '%' : '--'}}</td> -->
                                <td *ngSwitchCase="'unit_price'" class="col-unit-price">
                                    <ng-container *ngIf="!item.is_buy_x_get_y_line && !item.is_gift; else noPrice">
                                        <ng-container>
                                            <!-- Inline unit price edit: available for all order types (AI, catalog, manual) -->
                                            <div class="price-inline-edit-container" (click)="$event.stopPropagation()">
                                                <!-- DISPLAY MODE -->
                                                <div class="price-display"
                                                     *ngIf="!isEditingPrice(item)"
                                                     (click)="!viewMode && !quotation.all_lines_no_price ? startEditPrice(item) : null">
                                                    <span class="price-value" [class.no-price]="item.price_type === 'none'">{{ item.price_type === 'none' ? ('quotations_and_orders.price_source_none' | translate) : (item.final_price ? item.final_price.toFixed(2) + currency?.symbol! : '--') }}</span>
                                                    <ui-svg-icon *ngIf="item.price_type" tooltip=""
                                                        [tooltipTemplate]="priceDetailsTpl"
                                                        [offsetLeft]="200"
                                                        [offsetTop]="-10"
                                                        [maxWidth]="'350px'"
                                                        svgIcon="info" size="medium" (click)="$event.stopPropagation()">
                                                    </ui-svg-icon>
                                                    <ui-svg-icon *ngIf="!viewMode && !quotation.all_lines_no_price" class="price-inline-edit-icon" (click)="startEditPrice(item); $event.stopPropagation()" svgIcon="inline-edit" size="medium"></ui-svg-icon>
                                                </div>

                                                <!-- EDIT MODE (override) -->
                                                <div class="price-edit standard-input" *ngIf="!viewMode && !quotation.all_lines_no_price && isEditingPrice(item)">
                                                    <input
                                                        type="number"
                                                        class="price-edit-input"
                                                        min="0"
                                                        step="any"
                                                        [value]="editPriceValue"
                                                        (input)="onEditPriceInput($event)"
                                                        (keyup.enter)="submitEditPrice(item)"
                                                        (keyup.escape)="cancelEditPrice()"
                                                    >
                                                    <ui-svg-icon class="price-edit-icon" (click)="submitEditPrice(item)" svgIcon="check-cc" size="medium"></ui-svg-icon>
                                                    <ui-svg-icon *ngIf="item.price_type" tooltip=""
                                                        [tooltipTemplate]="priceDetailsTpl"
                                                        [offsetLeft]="200"
                                                        [offsetTop]="-10"
                                                        [maxWidth]="'350px'"
                                                        svgIcon="info" size="medium" (click)="$event.stopPropagation()">
                                                    </ui-svg-icon>
                                                </div>

                                                <!-- Tooltip template -->
                                                <ng-template #priceDetailsTpl>
                                                    <app-price-details-tooltip
                                                        [product]="item"
                                                        [currencySymbol]="currency?.symbol || ''"
                                                        [viewMode]="!!(viewMode || quotation.all_lines_no_price)"
                                                        (applyPrice)="onApplyPriceFromTooltip(item, $event)">
                                                    </app-price-details-tooltip>
                                                </ng-template>
                                            </div>
                                        </ng-container>
                                        <div class="price-info-container">
                                            <span *ngIf="featureFlags.loyaltyEnabled && item.best_deal?.length" class="original-price">{{item.old_final_price ? item.old_final_price.toFixed(2) + currency?.symbol! : '--'}}</span>
                                        </div>
                                    </ng-container>
                                </td>
                                <td *ngSwitchCase="'total_amount'" class="col-total">
                                    <ng-container *ngIf="!item.is_buy_x_get_y_line && !item.is_gift; else noPrice">
                                        <span [class.no-price]="item.price_type === 'none'">{{ item.price_type === 'none' ? ('quotations_and_orders.price_source_none' | translate) : (item.total ? (item.total).toFixed(2) + currency?.symbol! : '--') }}</span>
                                        <div *ngIf="featureFlags.loyaltyEnabled && item.best_deal?.length" class="original-price">{{item.old_total_amount ? (item.old_total_amount).toFixed(2) + currency?.symbol! : '--'}}</div>
                                    </ng-container>
                                </td>
                                <td *ngSwitchCase="'profit_margin'" class="col-profit">
                                    <ng-container *ngIf="item.price_type === 'none'; else profitMarginValues">
                                      <span class="profit-amount no-price">{{ 'quotations_and_orders.price_source_none' | translate }}</span>
                                    </ng-container>
                                    <ng-template #profitMarginValues>
                                    <span class="profit-amount">
                                        <div class="price-info" [style]="{flexDirection: 'row', alignItems: 'center', gap: '5px'}">
                                            <!-- <span *ngIf="item.best_deal?.length" class="original-price">{{item.cost && item.old_profit ? item.old_profit + currency?.symbol! : '--'}}</span> -->
                                            <span>{{ item.cost && item.final_price ? (((item.final_price - item.cost) * item.quantity) | number:'1.2-2') + currency?.symbol! : '--'}}</span>
                                        </div>
                                    </span>
                                    <span class="profit-markup">
                                        <div class="price-info" [style]="{flexDirection: 'row', alignItems: 'center', gap: '5px'}">
                                            <!-- <span *ngIf="item.best_deal?.length" class="original-price">{{item.cost && item.old_markup ? item.old_markup + '%' : '--'}}</span> -->
                                            <span>{{ item.cost && item.final_price ? (((item.final_price - item.cost) / item.final_price * 100) | number:'1.2-2') + '%' : '--'}}</span>
                                        </div>
                                    </span>
                                    </ng-template>
                                </td>
                                <ng-template #noPrice>
                                    <span>0.00 {{currency?.symbol!}}</span>
                                </ng-template>
                                <td *ngSwitchCase="'delivery_date'" class="col-delivery">
                                    <div class="delivery-inline-edit-container" (click)="$event.stopPropagation()">
                                        <!-- DISPLAY MODE -->
                                        <div class="delivery-display"
                                             *ngIf="!isEditingDelivery(item)"
                                             (click)="!viewMode ? startEditDelivery(item) : null"
                                             [class.delivery-display-view-mode]="viewMode">
                                            <span class="delivery-value">{{ getFormattedDeliveryDate(item) }}</span>
                                            <ui-svg-icon *ngIf="!viewMode" class="delivery-inline-edit-icon" svgIcon="inline-edit" size="medium"></ui-svg-icon>
                                        </div>

                                        <!-- EDIT MODE -->
                                        <div class="delivery-edit" *ngIf="!viewMode && isEditingDelivery(item)">
                                            <div class="standard-input has-icon">
                                                <div class="input-container">
                                                    <input
                                                        type="text"
                                                        matInput
                                                        [matDatepicker]="picker"
                                                        class="standard-input-value"
                                                        [placeholder]="'common.select_date' | translate"
                                                        [value]="editDeliveryDate"
                                                        (dateChange)="onDeliveryDateChange($event, item)"
                                                        (click)="picker.open()"
                                                    />
                                                    <button
                                                        type="button"
                                                        class="btn-icon"
                                                        (click)="picker.open()"
                                                        tabindex="-1"
                                                        [attr.aria-label]="'quotations_and_orders.side_by_side_panel.open_calendar' | translate"
                                                    >
                                                        <ui-svg-icon svgIcon="calendar-cc"></ui-svg-icon>
                                                    </button>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </div>
                                            </div>
                                            <ui-svg-icon class="qty-edit-icon" (click)="submitEditDelivery(item)" svgIcon="check-cc" size="medium"></ui-svg-icon>
                                        </div>
                                    </div>
                                </td>
                                <td *ngSwitchCase="'stock'" class="col-stock">
                                    <ng-container *ngIf="item.stock !== null && item.stock !== undefined; else stockEmpty">
                                        {{ item.stock }}
                                    </ng-container>
                                    <ng-template #stockEmpty>--</ng-template>
                                </td>
                                <!-- Product custom field columns (WB-7619) — read-only. -->
                                <ng-container *ngSwitchDefault>
                                <td *ngIf="customFieldCell(item, key) as cell" class="col-custom-field">
                                    <ng-container [ngSwitch]="cell.kind">
                                        <span *ngSwitchCase="'chips'" class="custom-field-chips">
                                            <span class="custom-field-chip" *ngFor="let chip of cell.chips">{{ chip }}</span>
                                        </span>
                                        <a *ngSwitchCase="'link'" [href]="cell.href" target="_blank" rel="noopener noreferrer"
                                           class="custom-field-link" (click)="$event.stopPropagation()">{{ cell.text }}</a>
                                        <span *ngSwitchDefault>{{ cell.text }}</span>
                                    </ng-container>
                                </td>
                                </ng-container>
                                </ng-container>
                                <td *ngIf="(quotation$ | async)?.channel == 'Agent portal'" class="col-total">{{item.commission_amount ? item.commission_amount + currency?.symbol! : '--'}}</td>
                            </tr>
                            <!-- <tr *ngIf="!item.final_price && !item.duplicated" (click)="showStockFulfillment(item)">
                                <td [attr.colspan]="visibleTableColumnsCount" class="alert-cell">
                                    <div class="alert_div alert_div_danger">
                                        <div class="alert_div_content">
                                            <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                                            <span class="error-message">{{'quotations_and_orders.no_pricing_information' | translate}}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!isMultiWarehouseStock(item) && isStockAlert(item) && item.final_price && !item.duplicated" (click)="showStockFulfillment(item)">
                                <td [attr.colspan]="visibleTableColumnsCount" class="alert-cell">
                                    <div [class]="alertType(item)" class="alert_div">
                                        <div class="alert_div_content" [tooltip]="'.killing_stock_details'" [offsetLeft]="30" [offsetTop]="66">
                                            <img *ngIf="alertType(item) === 'alert_div_danger'" src="assets/icones/alert_icon.svg" alt="alert-icon">
                                            <img *ngIf="alertType(item) === 'alert_div_warning'" src="assets/icones/warning_icon.svg" alt="alert-icon">
                                            <span class="error-message">{{alertMessage(item) + '.label' | translate}}</span>
                                            <div class="tooltip-content">
                                                <div class="killing_stock_details">
                                                    {{ alertMessage(item) + '.details' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="alertQuantityRules(item) !== '' && !isStockAlert(item) && item.final_price && !item.duplicated" (click)="showStockFulfillment(item)">
                                <td [attr.colspan]="visibleTableColumnsCount" class="alert-cell">
                                    <div class="alert_div alert_div_warning">
                                        <div class="alert_div_content">
                                            <img src="assets/icones/warning_icon.svg" alt="alert-icon">
                                            <span class="error-message">{{alertQuantityRules(item) | translate}}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="isMultiWarehouseStock(item) && hasErrorStock(item)" (click)="showStockFulfillment(item)">
                                <td [attr.colspan]="visibleTableColumnsCount" class="alert-cell" style="white-space: pre-wrap;">
                                    <div *ngIf="outOfStock(item)" class="alert_div alert_div_danger" style="white-space: pre-wrap;">
                                        <app-svg-icon svgIcon="inventory"></app-svg-icon>
                                        <div>{{"quotations_and_orders.warehouse_stock.quantity_exceeded_global_stock" | translate}} <a>{{"quotations_and_orders.warehouse_stock.fix_issue" | translate}} →</a></div>
                                    </div>
                                    <div *ngIf="!outOfStock(item) &&outOfStockMainWarehouse(item)" class="alert_div alert_div_warning" style="white-space: pre-wrap;">
                                        <app-svg-icon svgIcon="inventory"></app-svg-icon>
                                        <div>{{"quotations_and_orders.warehouse_stock.quantity_exceeded_default_warehouse" | translate}} <a>{{"quotations_and_orders.warehouse_stock.confirm_split" | translate}} →</a></div>
                                    </div>
                                </td>
                            </tr> -->
                        </ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                    </div>
                     <div class="lines-load-more" *ngIf="hasMoreQuotationProducts || linesLoading">
                      <mat-spinner *ngIf="linesLoading" diameter="20"></mat-spinner>
                      <button *ngIf="hasMoreQuotationProducts && !linesLoading" type="button" class="btn-secondary load-more-btn" (click)="loadMoreQuotationProducts()">
                        {{ 'common.load_more' | translate }}
                      </button>
                    </div>
                    <!-- Add Product Search -->
                    <div class="search-box-container" *ngIf="!viewMode && isAddProductMode">
                      <div class="standard-input has-icon search-box">
                        <div class="input-container">
                          <input type="text"
                            [placeholder]="'quotations_and_orders.side_by_side_panel.search_by_name_or_reference' | translate"
                            [matAutocomplete]="addProductAuto"
                            (input)="onAddProductSearch($event)"
                            (keydown)="onAddProductKeydown($event)"
                            #addProductInput
                            #addProductAutoTrigger="matAutocompleteTrigger"
                          />
                          <mat-autocomplete #addProductAuto="matAutocomplete" [autoActiveFirstOption]="true" (optionSelected)="onAddProductOptionSelected($event)" (opened)="onAutocompleteOpened()" (closed)="onAutocompleteClosed()">
                            <mat-option class="product-option" *ngFor="let voltaProduct of searchProducts$ | async" [value]="voltaProduct">
                              <div class="product-details-block">
                                <div class="product-icon">
                                  <img class="col-img" [src]="voltaProduct.image ? baseUrl + voltaProduct.image + '?thumbnail=1' : placeholder" alt="">
                                </div>
                                <div class="product-details">
                                  <span class="product-name">{{voltaProduct.name}}</span>
                                  <span class="product-sku">{{voltaProduct | productCode}}</span>
                                </div>
                              </div>
                            </mat-option>
                            <mat-option *ngIf="isSearchLoading" disabled class="search-loader-option">
                              <div class="search-loader">
                                <span class="search-spinner"></span>
                              </div>
                            </mat-option>
                          </mat-autocomplete>
                          <span class="btn-icon" style="cursor: default;">
                            <ui-svg-icon svgIcon="search_icon"></ui-svg-icon>
                          </span>
                        </div>
                      </div>
                      <ui-button type="danger" icon="trash-cc" (click)="cancelAddProduct()"></ui-button>
                    </div>
                    <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                        <div *ngIf="!viewMode" class="add_product">
                            <ui-button class="add_product_button" type="secondary" [label]="'inventory.add_product' | translate"
                                icon="plus-cc" iconPosition="start"
                                [disabled]="isAddProductMode"
                                (click)="startAddProduct()">
                            </ui-button>
                        </div>
                   </ng-container>
                </div>
                <div class="product-table-container prompt-to-order-loading-container" *ngIf="(isPromptToOrderLoading$ | async) === true">
                    <div class="prompt-to-order-loading-element" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]"></div>
                </div>
            </div>
         </div>
        <!-- Right Section: Details Tabs -->
        <div class="details-section">
            <div class="details-tabs">
                <div class="details-tabs-scroll">
                <button class="tab-button" [ngClass]="{'tab-button-active': activeTab === 'details'}" data-testid="order-tab-details" (click)="showTab('details')">{{"quotations_and_orders.details" | translate}}</button>
                <button class="tab-button" [ngClass]="{'tab-button-active': activeTab === 'activity'}" data-testid="order-tab-activity" (click)="showTab('activity')"><span class="activity-text">{{"quotations_and_orders.activity" | translate}}</span></button>
                <button class="tab-button" [ngClass]="{'tab-button-active': activeTab === 'documents'}" data-testid="order-tab-documents" (click)="showTab('documents')">{{"quotations_and_orders.documents" | translate}}</button>
                <button *ngIf="quotation?.channel === 'email' || quotation?.channel === 'prompt'" class="tab-button" [ngClass]="{'tab-button-active': activeTab === 'ai_analysis'}" data-testid="order-tab-ai-analysis" (click)="showTab('ai_analysis')">{{"quotations_and_orders.source" | translate}}</button>
                </div>

                <!-- Same slot and control as the products column picker. -->
                <ui-detail-fields-settings
                    *ngIf="activeTab === 'details'"
                    class="details-fields-settings"
                    [groups]="fieldGroups"
                    (groupChange)="onFieldGroupChange($event)"
                ></ui-detail-fields-settings>
            </div>
            <div class="details-content-area">
                <!-- Details Tab Content -->
                <div *ngIf="activeTab === 'details'">
                    <!-- ── Slots: rows whose value is richer than a string ── -->
                    <ng-template #companySlot>
                        <ng-container *ngIf="!isCompanyInformationMissing(); else companyMissing">
                            <a class="entity-tag entity-tag--single-line" target="_blank" routerLink="/companies/{{routingCompanyId()}}"
                               [matTooltip]="(quotation$ | async)?.order_company?.name || ''"
                               matTooltipClass="product-status-tooltip"
                               matTooltipPosition="above">
                                <ui-icon name="Store" size="medium"></ui-icon>
                                <span class="entity-tag__label">{{(quotation$ | async)?.order_company?.name}}</span>
                            </a>
                        </ng-container>
                        <ng-template #companyMissing>
                            <!--
                              FTUE anchor: the chip itself, not its container —
                              the tip points at the thing to click, and the chip
                              only exists while the company really is missing.
                            -->
                            <button type="button" class="entity-tag entity-tag--missing"
                                    [appFtueAnchor]="ftueAnchors.ORDER_COMPANY"
                                    [disabled]="!(stillEditable() && canEdit)"
                                    (click)="editCustomer()">
                                <ui-icon name="TriangleAlert" size="medium"></ui-icon>
                                <span class="entity-tag__label">{{"common.missing" | translate}}</span>
                            </button>
                        </ng-template>
                    </ng-template>

                    <ng-template #locationSlot>
                        <span class="entity-tag-stack" *ngIf="!isLocationInformationMissing()">
                            <a *ngIf="(quotation$ | async)?.location?.is_different_company"
                               class="entity-tag entity-tag--single-line" target="_blank"
                               routerLink="/companies/{{(quotation$ | async)?.location!.id}}"
                               [matTooltip]="(quotation$ | async)?.location?.company_name || ''"
                               matTooltipClass="product-status-tooltip"
                               matTooltipPosition="above">
                                <ui-icon name="Store" size="medium"></ui-icon>
                                <span class="entity-tag__label">{{(quotation$ | async)?.location?.company_name}}</span>
                            </a>
                            <div class="entity-tag-row">
                                <a class="entity-tag" target="_blank" routerLink="/companies/{{(quotation$ | async)?.location!.id}}"
                                   [matTooltip]="(quotation$ | async)?.location?.name || ''"
                                   matTooltipClass="product-status-tooltip"
                                   matTooltipPosition="above">
                                    <ui-icon name="MapPin" size="medium"></ui-icon>
                                    <span class="entity-tag__label">{{(quotation$ | async)?.location!.name}}</span>
                                </a>
                                <span
                                    *ngIf="(quotation$ | async)?.location?.provenance?.source === 'volta'"
                                    class="volta-location-icon"
                                    [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
                                    matTooltipClass="product-status-tooltip volta-location-tooltip"
                                    matTooltipPosition="above"
                                >
                                    <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
                                </span>
                                <span *ngIf="(quotation$ | async)?.location?.is_new" class="new-location-tag">
                                    {{ 'companies_selection_dialog.new' | translate }}
                                </span>
                                <span
                                    *ngIf="shippingAutofillSource() === 'single_location_fallback'"
                                    class="autofill-badge"
                                    [matTooltip]="'quotations_and_orders.side_by_side_panel.details.shipping_autofill.single_location' | translate"
                                    matTooltipClass="product-status-tooltip"
                                    matTooltipPosition="above"
                                >
                                    <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                                </span>
                            </div>
                        </span>
                        <div class="missing-information-container" *ngIf="isLocationInformationMissing()">
                            <ng-container *ngIf="isSingleLocationSoftMatch(); else plainMissing">
                                <div class="entity-tag-row soft-match-value">
                                    <span class="entity-tag entity-tag--static"
                                          [matTooltip]="suggestedShippingLocation()?.name || ''"
                                          matTooltipClass="product-status-tooltip"
                                          matTooltipPosition="above">
                                        <ui-icon name="MapPin" size="medium"></ui-icon>
                                        <span class="entity-tag__label">{{ suggestedShippingLocation()?.name }}</span>
                                    </span>
                                    <span class="soft-match-badge"
                                        [matTooltip]="'quotations_and_orders.side_by_side_panel.details.shipping_autofill.single_location_soft_match' | translate"
                                        matTooltipClass="product-status-tooltip"
                                        matTooltipPosition="above"
                                    >
                                        <span>{{ "quotations_and_orders.soft_match.suggestion" | translate }}</span>
                                    </span>
                                </div>
                            </ng-container>
                            <ng-template #plainMissing>
                                <button type="button" class="entity-tag entity-tag--missing"
                                    [disabled]="!(stillEditable() && canEdit)"
                                    (click)="editShippingAddress()"
                                    [matTooltip]="shippingHintTooltip()"
                                    matTooltipClass="product-status-tooltip"
                                    matTooltipPosition="above"
                                    [matTooltipDisabled]="!shippingHintTooltip()"
                                >
                                    <ui-icon name="TriangleAlert" size="medium"></ui-icon>
                                    <span class="entity-tag__label">{{"common.missing" | translate}}</span>
                                </button>
                            </ng-template>
                        </div>
                    </ng-template>

                    <!-- WB-7836 (review follow-up): the Shipping block reads
                         its own shipping_location, not the Customer/billing
                         location. -->
                    <ng-template #shippingAddressSlot>
                        <span *ngIf="!isLocationInformationMissing()"> {{(quotation$ | async)?.shipping_location?.shipping_address || '--'}} </span>
                        <span *ngIf="isSingleLocationSoftMatch()"> {{ suggestedShippingLocation()?.shipping_address || '--' }} </span>
                        <span *ngIf="isLocationInformationMissing() && !isSingleLocationSoftMatch()"> -- </span>
                    </ng-template>

                    <ng-template #mainContactSlot>
                        <span class="entity-tag entity-tag--static"
                              [matTooltip]="(quotation$ | async)?.shipping_location?.contacts_information?.[0]?.contact_fname || ''"
                              matTooltipClass="product-status-tooltip"
                              matTooltipPosition="above">
                            <ui-icon name="User" size="medium"></ui-icon>
                            <span class="entity-tag__label">{{(quotation$ | async)?.shipping_location?.contacts_information?.[0]?.contact_fname}}</span>
                        </span>
                    </ng-template>

                    <ng-template #contactEmailSlot>
                        <ng-container *ngIf="(quotation$ | async)?.shipping_location?.contacts_information?.[0]?.email as email">
                            <a class="contact-email-link" [href]="'mailto:' + email">{{ email || '--' }}</a>
                        </ng-container>
                    </ng-template>

                    <ng-template #freeShippingSlot>
                        <span class="details-badge free-badge">
                            <img src="assets/icones/gift.svg" alt=""/>
                            Free
                        </span>
                    </ng-template>

                    <!-- One tag per code: a location carries several types, and a
                         type several values. -->
                    <ng-template #taxCodesSlot>
                        <span class="tax-code-list" *ngIf="taxCodeTags.length; else noTaxCodes">
                            <span class="entity-tag entity-tag--static tax-code-tag" *ngFor="let code of taxCodeTags">
                                <span class="tax-code-tag__type">{{ code.type }}</span>
                                <ui-copyable [value]="code.value" [label]="code.type">{{ code.value }}</ui-copyable>
                            </span>
                        </span>
                        <ng-template #noTaxCodes><span>--</span></ng-template>
                    </ng-template>

                    <!-- Sits directly under the billing-company row, not at the end of the
                         block: the sentence names that row's value. -->
                    <ng-template #companyAlertSlot>
                        <div class="details-row" *ngIf="isCompanyInformationMissing() && (quotation$ | async)?.ai_details?.extracted_info?.customer?.company as extractedCompany">
                            <div class="ai-suggestion-card">
                                <div class="ai-suggestion-card__content">
                                    <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                                    <span>
                                        <ui-copyable [value]="extractedCompany"><strong>{{ extractedCompany }}</strong></ui-copyable>
                                        {{ "quotations_and_orders.soft_match.company_not_in_system" | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <!-- ── Customer ────────────────────────────────────────── -->
                    <ui-detail-field-list
                        class="customer-section"
                        heading="quotations_and_orders.customer"
                        [fields]="customerFields"
                        [editable]="stillEditable() && canEdit"
                        [slots]="{ company: companySlot }"
                        (fieldEdit)="onDetailFieldEdit($event)"
                        (fieldValueChange)="onDetailFieldValueChange($event)"
                        [afterSlots]="{ company: companyAlertSlot }"
                    ></ui-detail-field-list>

                    <hr class="details-divider"/>

                    <!-- ── Shipping ────────────────────────────────────────── -->
                    <ui-detail-field-list
                        class="shipping-section"
                        heading="companies.shipping"
                        [fields]="shippingFields"
                        [editable]="stillEditable() && canEdit"
                        [slots]="{
                            location: locationSlot,
                            shipping_address: shippingAddressSlot,
                            main_contact: mainContactSlot,
                            contact_email: contactEmailSlot,
                            free_shipping: freeShippingSlot,
                            tax_codes: taxCodesSlot
                        }"
                        (fieldEdit)="onDetailFieldEdit($event)"
                        (fieldValueChange)="onDetailFieldValueChange($event)"
                    >
                        <!-- Contextual cards; never configurable, so they are
                             projected rather than declared as fields. -->
                        <div class="details-row" *ngIf="isSingleLocationSoftMatch()">
                            <div class="ai-suggestion-card" *appHasPermission="{ module: 'order', action: 'edit' }">
                                <div class="ai-suggestion-card__content">
                                    <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                                    <span>{{ "quotations_and_orders.soft_match.accept_suggested_location" | translate }}</span>
                                </div>
                                <button type="button" class="ai-suggestion-card__btn accept"
                                    (click)="acceptSuggestedLocation()"
                                    [attr.aria-label]="'common.accept' | translate">
                                    <ui-svg-icon svgIcon="check-cc" size="medium"></ui-svg-icon>
                                </button>
                                <button type="button" class="ai-suggestion-card__btn discard"
                                    (click)="discardSuggestedLocation()"
                                    [attr.aria-label]="'common.discard' | translate">
                                    <ui-svg-icon svgIcon="close-cc" size="medium"></ui-svg-icon>
                                </button>
                            </div>
                        </div>
                        <div class="details-row" *ngIf="isLocationInformationMissing() && (quotation$ | async)?.ai_details?.extracted_info?.shipping?.raw_address as rawShippingAddress">
                            <div class="ai-suggestion-card">
                                <div class="ai-suggestion-card__content">
                                    <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                                    <span><strong>{{ rawShippingAddress }}</strong> {{ "quotations_and_orders.soft_match.address_not_in_system" | translate }}</span>
                                </div>
                                <ng-container *ngIf="featureFlags.allowCreateShippingAddress">
                                    <button type="button" class="ai-suggestion-card__btn add"
                                        *appHasPermission="{ module: 'order', action: 'edit' }"
                                        (click)="addNewLocation()"
                                        [attr.aria-label]="'common.add' | translate">
                                        <ui-svg-icon svgIcon="add_icon" size="medium"></ui-svg-icon>
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                        <div class="details-row" *ngIf="(quotation$ | async)?.location?.is_different_company">
                            <span class="details-value company-diff-alert">
                                <img src="assets/icones/alert-circle.svg" alt="">
                                <span class="company-diff-alert-text">{{"companies_selection_dialog.billing_shipping_different" | translate}}</span>
                            </span>
                        </div>
                    </ui-detail-field-list>

                    <hr class="details-divider"/>

                    <!-- ── Order references ────────────────────────────────── -->
                    <ui-detail-field-list
                        class="conditions-section"
                        heading="quotations_and_orders.order_references"
                        [fields]="orderReferenceFields"
                        [editable]="stillEditable() && canEdit"
                        (fieldValueChange)="onDetailFieldValueChange($event)"
                    >
                        <div *ngIf="isAiOrder() && extractedNotes?.extracted?.length" class="details-row flex-column">
                            <span class="details-label">{{ 'quotations_and_orders.extracted_notes' | translate }}</span>
                            <app-extracted-notes-editor
                              class="full-width"
                              [notes]="extractedNotes"
                              [editable]="stillEditable() && canEdit"
                              (notesSave)="onExtractedNotesSave($event)"
                            ></app-extracted-notes-editor>
                        </div>

                        <div *ngIf="featureFlags.loyaltyEnabled && getDeals().length > 0" class="details-row" [style.alignItems]="'start'">
                            <span class="details-label">{{ "quotations_and_orders.price_book_rules_applied" | translate }}</span>
                            <span class="details-value" style="display: flex; flex-direction: column; align-items: start; gap: 5px;">
                                <div *ngFor="let deal of getDeals()" [style]="{
                                    display: 'flex',
                                    alignItems: 'start',
                                    gap: '5px'
                                }">
                                    <img src="assets/icones/gift.svg" alt=""/> {{ deal.name }}
                                </div>
                            </span>
                        </div>
                    </ui-detail-field-list>

                    <hr class="details-divider"/>

                    <!-- ── Custom fields ───────────────────────────────────── -->
                    <ui-detail-field-list
                        class="custom-fields-section"
                        heading="custom_fields.custom_fields"
                        [fields]="orderCustomFieldRows"
                        [editable]="stillEditable() && canEdit"
                        (fieldValueChange)="onDetailFieldValueChange($event)"
                    >
                        <!-- Selects, booleans and rich text cannot be edited in
                             place, so the dialog stays reachable for them. -->
                        <ng-container detailFieldListActions *appHasPermission="{ module: 'order', action: 'edit' }">
                            <button
                                type="button"
                                class="details-edit-button"
                                *ngIf="stillEditable() && hasDialogOnlyCustomFields()"
                                (click)="editCustomFields()"
                                [attr.aria-label]="'common.edit' | translate"
                            >
                                <img src="assets/icones/edit_icon.svg" alt="">
                            </button>
                        </ng-container>
                    </ui-detail-field-list>

                    <hr class="details-divider"/>

                    <!-- ── Details (never configurable) ────────────────────── -->
                    <div class="order-details-section">
                        <h3 class="details-section-header">{{ 'quotations_and_orders.details' | translate }}</h3>

                        <div class="details-row">
                            <span class="details-label">{{"companies.order_channel" | translate}}</span>
                            <span class="details-value">
                                <span class="details-badge order-channel-badge" [class]="quotation.channel == 'BO portal' || quotation.channel == 'prompt' ? 'backoffice' : 'email'">
                                    <img *ngIf="quotation.channel === 'email'" src="assets/icones/email.svg" alt="">
                                    <img *ngIf="quotation.channel === 'B2B portal' || quotation.channel === 'Agent portal'" src="assets/icones/volta_smal_icon.svg" alt="">
                                    <img *ngIf="quotation.channel === 'BO portal' || quotation.channel === 'prompt'" src="assets/icones/volta_small_icon_tr.svg" alt="">
                                    <span *ngIf="quotation.channel === 'BO portal' || quotation.channel === 'prompt'">{{ 'quotations_and_orders.backoffice' | translate }}</span>
                                    <span *ngIf="quotation.channel === 'B2B portal'">{{ 'quotations_and_orders.b2b_portal' | translate }}</span>
                                    <span *ngIf="quotation.channel === 'Agent portal'">{{ 'quotations_and_orders.agent_portal' | translate }}</span>
                                    <span *ngIf="quotation.channel === 'email'">{{ 'quotations_and_orders.email' | translate }}</span>
                                </span>
                            </span>
                        </div>

                        <ng-container *ngIf="quotation$ | async as rootQ">
                            <div class="details-row ownership-inline-row" *appFieldVisible="{ module: 'order', field: 'order_creator' }">
                                <span class="details-label">{{ 'quotations_and_orders.ownership.created_by' | translate }}</span>
                                <span class="details-value ownership-inline-value">
                                    <ng-container *ngIf="rootQ.order_creator as cr; else noCreator">
                                        <span class="own-avatar-circle" [style.background]="getUserColor(cr)" aria-hidden="true">{{ userChipInitials(cr.name) }}</span>
                                        <span class="own-display-name">{{ cr.name }}</span>
                                    </ng-container>
                                    <ng-template #noCreator><span class="own-dash">—</span></ng-template>
                                </span>
                            </div>
                            <div class="details-row ownership-inline-row" *appFieldVisible="{ module: 'order', field: 'owner' }">
                                <span class="details-label">{{ 'quotations_and_orders.ownership.owner' | translate }}</span>
                                <span class="details-value ownership-inline-value ownership-owner-with-action">
                                    <ng-container *ngIf="rootQ.owner as ow; else noOwner">
                                        <span class="own-avatar-circle" [style.background]="getUserColor(ow)" aria-hidden="true">{{ userChipInitials(ow.name) }}</span>
                                        <span class="own-display-name">{{ ow.name }}</span>
                                    </ng-container>
                                    <ng-template #noOwner><span class="own-dash">—</span></ng-template>
                                    <div class="owner-actions">
                                        <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                                            <button
                                                type="button"
                                                class="details-edit-button"
                                                *ngIf="stillEditable()"
                                                (click)="openChangeOwnerDialog(); $event.stopPropagation()"
                                                [attr.aria-label]="'quotations_and_orders.ownership.change_owner' | translate"
                                            >
                                                <img src="assets/icones/edit_icon.svg" alt="">
                                            </button>
                                        </ng-container>
                                    </div>
                                </span>
                            </div>
                        </ng-container>

                        <div class="details-row" *ngIf="isMarginOnCost">
                            <span class="details-label">{{"quotations_and_orders.order_margin" | translate}}</span>
                            <span class="details-value order-margin-value">
                                <span class="order-margin-amount">
                                    {{ getOrderMarginAmount() | number:'1.2-2' }} {{ currency?.symbol }}
                                </span>
                                <span class="order-margin-percentage">
                                    {{ getOrderMarginPercentage() | number:'1.2-2' }}%
                                </span>
                            </span>
                        </div>

                        <div class="details-row" *ngIf="(quotation$ | async)?.agent">
                            <span class="details-label">{{"quotations_and_orders.agent" | translate}}</span>
                            <span class="details-value">
                                <span class="details-badge">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M10.6667 14.5V3.83333C10.6667 3.47971 10.5262 3.14057 10.2762 2.89052C10.0261 2.64048 9.687 2.5 9.33337 2.5H6.66671C6.31309 2.5 5.97395 2.64048 5.7239 2.89052C5.47385 3.14057 5.33337 3.47971 5.33337 3.83333V14.5M2.66671 5.16667H13.3334C14.0698 5.16667 14.6667 5.76362 14.6667 6.5V13.1667C14.6667 13.903 14.0698 14.5 13.3334 14.5H2.66671C1.93033 14.5 1.33337 13.903 1.33337 13.1667V6.5C1.33337 5.76362 1.93033 5.16667 2.66671 5.16667Z" stroke="#232529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    <span>{{(quotation$ | async)?.agent ? (quotation$ | async)?.agent?.first_name + ' ' + (quotation$ | async)?.agent?.last_name: ''}}</span>
                                </span>
                            </span>
                        </div>
                        <div class="details-row" *ngIf="(quotation$ | async)?.agent">
                            <span class="details-label">{{"quotations_and_orders.total_commission" | translate}}</span>
                            <span class="details-value">
                                <span>
                                    <span>{{(quotation$ | async)?.agent ? (quotation$ | async)?.agent?.commission_total : ''}}</span>
                                    <span>{{(quotation$ | async)?.currency ? (quotation$ | async)?.currency?.symbol : (quotation$ | async)?.location?.currency?.symbol ?? ''}}</span>
                                </span>
                            </span>
                        </div>

                        <div class="details-row">
                            <span class="details-label">{{"companies.creation_date" | translate}}</span>
                            <span class="details-value">{{quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                        </div>
                        <div class="details-row" *ngIf="quotation.archived_at">
                            <span class="details-label">{{"quotations_and_orders.list_quotations.archived_on" | translate}}</span>
                            <span class="details-value">{{quotation.archived_at | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                        </div>

                        <!-- Split provenance, in the same label/value rhythm as
                             the rows above rather than its own panel styling. -->
                        <ng-container *ngIf="(quotation$ | async) as q">
                            <!-- The row stays compact; the rule that produced the
                                 split (mechanism, condition type, matched value)
                                 lives in the hover popover. -->
                            <div class="details-row" *ngIf="q.segregation_info as info">
                                <span class="details-label">{{ 'quotations_and_orders.segregation.split_from' | translate }}</span>
                                <span class="details-value seg-inline-value">
                                    <a class="entity-tag" [routerLink]="['/quotations', info.source_id]">
                                        <ui-icon name="Split" size="medium"></ui-icon>
                                        <span class="entity-tag__label">{{ info.source_name }}</span>
                                    </a>
                                    <span class="seg-info-trigger"
                                          [matTooltip]="segregationRuleSummary(info)"
                                          matTooltipClass="product-status-tooltip seg-info-tooltip"
                                          matTooltipPosition="above">
                                        <ui-icon name="Info" size="medium"></ui-icon>
                                    </span>
                                </span>
                            </div>

                            <div class="details-row" *ngIf="q.segregation_splits && q.segregation_splits.length" [style.alignItems]="'start'">
                                <span class="details-label">{{ 'quotations_and_orders.segregation.split_into' | translate }}</span>
                                <span class="details-value seg-inline-list">
                                    <span class="seg-inline-row" *ngFor="let split of q.segregation_splits">
                                        <a class="entity-tag" [routerLink]="['/quotations', split.id]">
                                            <ui-icon name="Split" size="medium"></ui-icon>
                                            <span class="entity-tag__label">{{ split.name }}</span>
                                        </a>
                                        <span class="seg-info-trigger"
                                              [matTooltip]="segregationRuleSummary(split)"
                                              matTooltipClass="product-status-tooltip seg-info-tooltip"
                                              matTooltipPosition="above">
                                            <ui-icon name="Info" size="medium"></ui-icon>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(quotation$ | async)?.retailer_comment">
                            <h3 class="details-section-header">{{"companies.retailerCommentsHeader" | translate}}</h3>
                            <span>{{(quotation$ | async)?.retailer_comment || '--'}}</span>
                        </ng-container>

                        <ng-container *ngIf="(quotation$ | async)?.location?.notes?.length">
                            <h3 class="details-section-header">{{"companies.customer_notes" | translate}}</h3>
                            <ul class="notes-list">
                                <li *ngFor="let note of (quotation$ | async)?.location?.notes">{{note.content}}</li>
                            </ul>
                        </ng-container>
                    </div>
                    </div>
                <div *ngIf="activeTab === 'activity'">
                    <div *ngIf="historyLoading$ | async" class="search-loader" style="display: flex; justify-content: center; align-items: center; padding: 40px 0;">
                        <span class="search-spinner"></span>
                    </div>
                    <!-- Activity Content Start -->
                    <div class="activity-feed" *ngFor="let item of (fullHistory$ | async); let index = index; let last = last; let first = first">

                        <!-- Activity Item 1: Quote Accepted -->
                        <!-- <div class="activity-item activity-item-card">
                            <div class="activity-header">
                                <div class="activity-info">
                                    <div class="details-badge badge-tobevalidated">
                                        <span>To be validated</span>
                                    </div>
                                    <span class="details-value">The client accepted the quote on 16/04/2025</span>
                                </div>
                                <button class="details-edit-button" aria-label="Activity Options">
                                    Eye icon
                                     <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 12.5C1 12.5 5 4.5 12 4.5C19 4.5 23 12.5 23 12.5C23 12.5 19 20.5 12 20.5C5 20.5 1 12.5 1 12.5Z" stroke="#454545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z" stroke="#454545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="details-row">
                                <span class="details-label">Order amount</span>
                                <span class="details-value">4.250,00 €</span>
                            </div>
                            <div class="activity-suggestion">
                                 <button class="action-button approve-button">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                      <span>approve order</span>
                                 </button>
                                 <span class="details-value">Suggested action</span>
                            </div>
                        </div> -->

                        <!-- Separator -->
                        <!-- <div class="activity-separator">
                            <div></div>
                        </div> -->

                         <!-- Activity Item 2: Quote Sent -->
                        <!-- <div class="activity-item activity-item-row">
                            <div class="activity-info">
                                 <div class="details-badge badge-quotationsent">
                                     <span>Quotation Sent</span>
                                 </div>
                                 <span class="details-value">You sent a quote on 04/04/2025</span>
                            </div>
                            <button class="details-edit-button" aria-label="Activity Options">
                                 Eye icon
                                 <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 12.5C1 12.5 5 4.5 12 4.5C19 4.5 23 12.5 23 12.5C23 12.5 19 20.5 12 20.5C5 20.5 1 12.5 1 12.5Z" stroke="#454545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z" stroke="#454545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div> -->

                         <!-- Separator -->
                        <!-- <div class="activity-separator">
                            <div></div>
                        </div> -->

                        <!-- Activity Item: Automation (workflow-triggered) — one card per rule run -->
                        <div class="activity-item activity-item-card activity-item-automation" *ngIf="item.source === 'automation'">
                            <div class="activity-header">
                                <div class="automation-title-row">
                                    <span class="automation-bolt"><ui-svg-icon svgIcon="bolt" size="medium"></ui-svg-icon></span>
                                    <span *ngIf="item.rule?.name" class="automation-rule-name">{{ item.rule?.name }}</span>
                                </div>
                            </div>
                            <div class="automation-actions">
                                <div class="automation-action-line" *ngFor="let act of item.actions">
                                    <span class="automation-action-label">{{ ('workflows.actions.' + act.action_type) | translate }}</span>
                                    <span class="oa-arrow">→</span>
                                    <span class="automation-action-target">{{ act.description }}</span>
                                </div>
                            </div>
                            <div class="automation-footer">
                                <span class="automation-triggered">{{ "quotations_and_orders.automation.triggered_by_rule" | translate }} · {{ item.create_date | adaptToUserUtcOffset | date: DATE_FORMAT }}</span>
                                <a *ngIf="item.rule?.id" class="automation-view-rule" [routerLink]="['/workflows/edit-rule', item.rule?.id]" target="_blank" rel="noopener">{{ "quotations_and_orders.automation.view_rule" | translate }} →</a>
                            </div>
                        </div>

                        <!-- Activity Item 3: Quote Requested -->
                        <div class="activity-item activity-item-card" *ngIf="item.event !== 'QUOTATION_DRAFTED' && item.source !== 'automation'">
                            <div class="activity-header">
                                <div class="activity-info">
                                     <div class="details-badge badge-quotationrequested" [ngClass]="getBadgeClass(item.event)">
                                         <span>{{getStatusTranslation(item.event)}}</span>
                                     </div>
                                     <span *ngIf="item.event === 'QUOTATION_REQUESTED'" class="details-value">{{ "quotations_and_orders.activity_descriptions.quote_requested" | translate }} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                                     <span *ngIf="item.event === 'QUOTATION_SENT'" class="details-value">{{ "quotations_and_orders.activity_descriptions.quote_sent" | translate }} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                                     <span *ngIf="item.event === 'QUOTATION_TO_BE_VALIDATED'" class="details-value">{{ "quotations_and_orders.activity_descriptions." + (item.quotation.channel === 'Agent portal' ? "agent_sent_order" : "quote_accepted") | translate }} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                                     <span *ngIf="item.event === 'QUOTATION_APPROVED'" class="details-value">{{ "quotations_and_orders.activity_descriptions.order_approved" | translate }} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                                </div>
                                <button class="details-edit-button" aria-label="Activity Options" (click)="previewQuote(item.quotation)">
                                    <img src="../../../../../assets/icones/eye_icon.svg" alt="">
                                </button>
                            </div>
                            <div class="activity-details-grid">
                                <div>
                                    <span class="details-label">{{"quotations_and_orders.number_of_sku"| translate}}</span>
                                    <div class="quantity_action">
                                        <!-- <span *ngIf="item.quotation.parent && item.quotation.parent.nbr_products !== item.quotation.nbr_products && item.event !== 'QUOTATION_ACCEPTED'">
                                            {{item.quotation.parent.nbr_products}}
                                        </span>
                                        <img *ngIf="item.quotation.parent && item.quotation.parent.nbr_products !== item.quotation.nbr_products && item.event !== 'QUOTATION_ACCEPTED'" class="right_arrow" src="assets/icones/right-arrow.svg" alt=""> -->
                                        <span class="details-value">{{item.quotation.nbr_products}}</span>
                                    </div>
                                </div>
                                <div *ngIf="featureFlags.showTotalQuantity">
                                    <span class="details-label">{{"quotations_and_orders.total_quantity"| translate}}</span>
                                    <div class="quantity_action">
                                        <span class="details-value">{{item.quotation.total_qty}}</span>
                                    </div>
                                </div>
                                 <div>
                                    <span class="details-label">{{"quotations_and_orders.order_amount" | translate}}</span>
                                    <div class="quantity_action">
                                        <span class="details-value details-value--masked" *ngIf="item.quotation.hide_pricing_columns; else amountOrNoPrice"
                                              [matTooltip]="'quotations_and_orders.pricing_hidden_for_order' | translate">—</span>
                                        <ng-template #amountOrNoPrice>
                                            <span class="details-value" *ngIf="item.quotation.all_lines_no_price; else amountValue">{{ "quotations_and_orders.price_source_none" | translate }}</span>
                                        </ng-template>
                                        <ng-template #amountValue>
                                            <!-- <span  *ngIf="item.quotation.parent &&  item.quotation.parent!.amount_total !== item.quotation.amount_total && item.event !== 'QUOTATION_ACCEPTED'">
                                                {{item.quotation.parent!.amount_total | number:'1.2-2'}} €
                                            </span>
                                            <img *ngIf="item.quotation.parent &&  item.quotation.parent!.amount_total !== item.quotation.amount_total && item.event !== 'QUOTATION_ACCEPTED'" class="right_arrow" src="assets/icones/right-arrow.svg" alt=""> -->
                                            <span class="details-value">{{(item.quotation.priced_lines_total ?? item.quotation.amount_total) | number:'1.2-2'}} €</span>
                                        </ng-template>
                                    </div>
                                 </div>
                            </div>

                            <div *ngIf="first">
                                <!-- Requested actions (send, reject) -->
                                <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                                    <ng-container *ngIf="quotation!.status === 'requested'">
                                        <div class="activity-suggestion">
                                            <button class="action-button approve-button" [disabled]="isApproveBlocked()" [matTooltip]="approveBlockedTooltip()" matTooltipClass="product-status-tooltip approve-blocked-tooltip" data-testid="order-action-approve" (click)="confirmAction('send_accepted_order')">
                                                <img class="btn-icon" src="assets/icones/check_icon.svg" alt="">
                                                <span>{{ 'quotations_and_orders.approve_order' | translate }}</span>
                                            </button>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!-- Sent actions (resend, accept) -->
                                <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                                    <ng-container *ngIf="quotation!.status === 'sent'">
                                        <div class="activity-suggestion">
                                            <button class="action-button approve-button" data-testid="order-action-send" (click)="confirmAction(quotation!.status)">
                                                <img class="btn-icon" src="assets/icones/orders.svg" alt="">
                                                <span >{{ 'quotations_and_orders.accept_and_sign' | translate }}</span>
                                            </button>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <!-- to_be_validated actions (cancel, approve) -->
                                <ng-container *appHasPermission="{ module: 'order', action: 'approve' }">
                                    <ng-container *ngIf="['to_be_validated', 'pending_inventory'].includes(quotation!.status)">
                                        <div class="activity-suggestion">
                                            <button class="action-button approve-button" [ngClass]="quotation && !isExpired(quotation.validity_date) ? 'approve-button' : 'btn-expired'" [disabled]="(quotation && isExpired(quotation.validity_date)) || isApproveBlocked()" [matTooltip]="approveBlockedTooltip()" matTooltipClass="product-status-tooltip approve-blocked-tooltip" data-testid="order-action-approve" (click)="isNavaPress ? checkQuotationAvailability() : confirmAction('to_be_validated')">
                                                <img src="assets/icones/check_icon.svg" alt="">
                                                <span >{{"quotations_and_orders.approve_order" | translate}}</span>
                                            </button>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Separator -->
                        <div *ngIf="!last" class="activity-separator">
                            <div></div>
                        </div>

                         <!-- Activity Item 4: Draft Created -->
                         <div class="activity-item activity-item-row" *ngIf="item.event === 'QUOTATION_DRAFTED' && quotation.channel === 'email'">
                            <div class="activity-info">
                                 <div class="details-badge badge-draft">
                                     <span>{{getStatusTranslation(item.event)}}</span>
                                 </div>
                                 <span class="details-value">{{"common.create_on" | translate}} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                            </div>
                            <button class="details-edit-button" aria-label="Activity Options" (click)="previewQuote(item.quotation)">
                                <img src="../../../../../assets/icones/eye_icon.svg" alt="">
                            </button>
                        </div>

                        <!-- Separator -->
                        <div *ngIf="quotation.channel === 'email' && last" class="activity-separator">
                            <div></div>
                        </div>

                        <!-- AI Generated -->
                        <div class="panner-container activity-item activity-item-row activity-item-row-ai" *ngIf="quotation.channel === 'email' && last">
                            <div class="activity-info">
                                 <img class="ai-volta-btn" src="assets/icones/ai-volta-btn.svg" alt="">
                                 <div class="ai-volta-text">
                                    <span>{{ 'quotations_and_orders.ai_generated_order.summary' | translate }}</span>
                                    <span class="ai-volta-email-from" *ngIf="quotationSourceContent?.email?.from as emailFrom">{{ 'quotations_and_orders.ai_generated_order.from' | translate }} {{ emailFrom }}</span>
                                 </div>
                           </div>
                        </div>

                    </div>

                    <!-- Ownership History in Activity Tab -->
                    <ng-container *ngIf="(quotation$ | async) as rootQ">
                      <ng-container *ngIf="rootQ.ownership_history?.length">
                        <div *ngIf="(fullHistory$ | async)?.length" class="activity-separator"><div></div></div>
                        <div id="ownership-history-anchor" class="ownership-history-section">
                          <div class="ownership-history-header">
                            <img src="assets/icones/quote_history.svg" alt="" width="16" height="16">
                            <span>{{ 'quotations_and_orders.ownership.history' | translate }}</span>
                          </div>
                          <div class="activity-feed ownership-history-feed">
                            <ng-container *ngFor="let h of rootQ.ownership_history; let hlast = last">
                              <div class="activity-item ownership-activity-item">
                                <div class="ownership-activity-row">
                                  <div class="ownership-activity-avatar" [style.background]="h.changed_by ? getUserColor(h.changed_by) : null">
                                    <ng-container *ngIf="h.changed_by; else genericAvatar">{{ userChipInitials(h.changed_by.name) }}</ng-container>
                                    <ng-template #genericAvatar><img src="assets/icones/person.svg" alt="" width="14" height="14" /></ng-template>
                                  </div>
                                  <div class="ownership-activity-text">
                                    <div class="ownership-activity-desc">
                                      <ng-container *ngIf="h.changed_by">
                                        <span class="oa-actor">{{ h.changed_by.name }}</span>
                                      </ng-container>
                                      <span class="oa-verb"> {{ 'quotations_and_orders.ownership.owner_changed_activity' | translate }} </span>
                                      <span class="oa-user oa-from">
                                        <ng-container *ngIf="h.previous_owner">{{ h.previous_owner.name }}</ng-container>
                                        <ng-container *ngIf="!h.previous_owner">—</ng-container>
                                      </span>
                                      <span class="oa-arrow">→</span>
                                      <span class="oa-user oa-to">{{ h.new_owner?.name }}</span>
                                    </div>
                                    <span *ngIf="h.note" class="ownership-note oa-note">{{ h.note }}</span>
                                  </div>
                                  <span class="ownership-activity-date">{{ h.changed_at | adaptToUserUtcOffset | date: DATE_FORMAT }}</span>
                                </div>
                              </div>
                              <div *ngIf="!hlast" class="activity-separator ownership-activity-sep"><div></div></div>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                    <!-- Activity Content End -->
                </div>
                <div *ngIf="activeTab === 'documents'">
                    <!-- Document List Container -->
                    <div class="document-list-container">
                        <!-- Document Item 1 -->
                        <ng-container *ngFor="let item of (fullHistory$ | async); let index = index; let last = last">
                        <div class="document-item" *ngIf="item.source !== 'automation'">
                            <div class="document-item-row">
                                <!-- File Icon -->
                                <div class="document-icon-wrapper">
                                  <img src="../../../../../assets/icones/file_icon.svg" alt="">
                                </div>
                                <!-- Document Info -->
                                <div class="document-info">
                                    <span class="document-title">{{getStatusTranslation(item.event)}}</span>
                                    <span class="document-generated-date">{{ "quotations_and_orders.generated_on" | translate }} {{item.quotation.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                                </div>
                                <!-- Action Button -->
                                <button class="document-action-button"
                                        data-testid="order-document-download"
                                        [title]="'quotations_and_orders.download_tooltip' | translate"
                                        [matMenuTriggerFor]="downloadMenu"
                                        [matMenuTriggerData]="{ quotation: item.quotation }">
                                    <img src="../../../../../assets/icones/download.svg" alt="">
                                </button>
                            </div>
                        </div>
                        </ng-container>
                    </div>
                    <mat-menu #downloadMenu="matMenu" xPosition="before" class="download-menu">
                        <ng-template matMenuContent let-quotation="quotation">
                            <button mat-menu-item data-testid="order-download-pdf" (click)="downloadFile(quotation, 'download')">
                                <img class="menu-icon" src="../../../../../assets/icones/pdf-file.svg" alt="">
                                <span>{{ "quotations_and_orders.download_pdf" | translate }}</span>
                            </button>
                            <button mat-menu-item data-testid="order-download-csv" (click)="downloadCsv(quotation)">
                                <img class="menu-icon" src="../../../../../assets/icones/csv-file.svg" alt="">
                                <span>{{ "quotations_and_orders.download_csv" | translate }}</span>
                            </button>
                        </ng-template>
                    </mat-menu>
                </div>
                <!-- Ai analysis tab -->
                <div *ngIf="activeTab === 'ai_analysis'">
                    <!-- Bound to the component field (kept in sync with the store by `sub8`), not the
                         store observable directly -- the field is also where the WB-7337 split-order
                         document fallback (`maybeLoadFallbackSourceAttachments`) merges in borrowed
                         attachments, which the store's own `quotationSourceContent$` never carries. -->
                    <ng-container *ngIf="quotationSourceContent">
                        <div class="customer-section">
                            <div class="analysis-section">
                                <div class="details-section-header">{{"quotations_and_orders.source_content.intent" | translate}}</div>
                                <div class="standard-input">
                                    <select (change)="onIntentChange($event)" [disabled]="intentDisabled()">
                                        <option [value]="2" [selected]="quotationSourceContent.ai_details?.intent === 2">{{"quotations_and_orders.source_content.order_placing" | translate}}</option>
                                        <option [value]="1" [selected]="quotationSourceContent.ai_details?.intent === 1">{{"quotations_and_orders.source_content.quotation_request" | translate}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="panner-container-intent">
                                <img src="assets/icones/info-blue.svg" alt="">
                                <div class="panner-content">
                                    <span *ngIf="quotationSourceContent.ai_details?.intent === 2">{{"quotations_and_orders.source_content.email_suggests_order_intent" | translate}}</span>
                                    <span *ngIf="quotationSourceContent.ai_details?.intent === 1">{{"quotations_and_orders.source_content.email_suggests_quotation_request" | translate}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Parsed sender + inline save-to-registry suggestion -->
                        <div class="customer-section" *ngIf="quotation.channel === 'email' && getSenderEmail(quotationSourceContent)">
                            <div class="details-row">
                                <span class="details-label">{{"quotations_and_orders.enrich_company_emails.original_sender" | translate}}</span>
                                <span class="details-value email_text email-highlight">
                                    <span class="email-ellipsis"
                                        [matTooltip]="getSenderEmail(quotationSourceContent) ?? ''"
                                        matTooltipClass="product-status-tooltip email-tooltip"
                                        matTooltipPosition="above">{{ getSenderEmail(quotationSourceContent) }}</span>
                                    <!-- <mat-icon
                                        *ngIf="isEmailInRegistry(getSenderEmail(quotationSourceContent))"
                                        class="email-registered-icon"
                                        [matTooltip]="'quotations_and_orders.enrich_company_emails.registered_tooltip' | translate"
                                        matTooltipPosition="above">
                                        check_circle
                                    </mat-icon> -->
                                    <ui-svg-icon *ngIf="isEmailInRegistry(getSenderEmail(quotationSourceContent))"
                                        svgIcon="check-icon"
                                        size="small"
                                        [matTooltip]="'quotations_and_orders.enrich_company_emails.registered_tooltip' | translate"
                                        matTooltipPosition="above"
                                    ></ui-svg-icon>
                                </span>
                            </div>
                            <ng-container *ngIf="getOtherEmails(quotationSourceContent) as otherEmails">
                                <div class="details-row" *ngIf="otherEmails.length">
                                    <span class="details-label">{{"quotations_and_orders.enrich_company_emails.other_emails" | translate}}</span>
                                    <span class="details-value email_text email-highlight">
                                        <span class="other-emails-list"
                                            [matTooltip]="otherEmails.join(', ')"
                                            matTooltipClass="product-status-tooltip email-tooltip"
                                            matTooltipPosition="above"><ng-container *ngFor="let email of otherEmails; let last = last">{{ email }}<ui-svg-icon
                                                    *ngIf="isEmailInRegistry(email)"
                                                    svgIcon="check-icon"
                                                    size="small"
                                                    [matTooltip]="'quotations_and_orders.enrich_company_emails.registered_tooltip' | translate"
                                                    matTooltipPosition="above"
                                                ></ui-svg-icon><span *ngIf="!last">,&nbsp;</span></ng-container></span>
                                    </span>
                                </div>
                            </ng-container>
                            <div class="enrich-company-card">
                                <app-enrich-company-emails-card
                                    [emails]="getParsedEmails(quotationSourceContent)"
                                    [company]="quotation?.order_company ?? null"
                                    [registeredEmails]="companyRegistryEmails"
                                    [registryLoaded]="companyRegistryLoaded"
                                    [locations]="companyLocations"
                                    (saved)="onCompanyEmailSaved($event)">
                                </app-enrich-company-emails-card>
                            </div>

                        </div>

                        <hr class="details-divider"/>
                        <div class="customer-section">
                            <div class="conditions-header inline-block">
                                <h3 class="details-section-header content-header">{{"quotations_and_orders.source_content.content" | translate}}</h3>
                                <span class="details-value">
                                   <span class="details-badge order-channel-badge backoffice">
                                       <img [src]="quotation.channel === 'email' ? 'assets/icones/email.svg' : 'assets/icones/edit.svg'" alt="">
                                       <span>{{quotation.channel}}</span>
                                   </span>
                               </span>
                            </div>
                            <ng-container>
                                <div *ngIf="quotation.channel === 'email'" class="details-row">
                                    <span class="details-label">{{"quotations_and_orders.source_content.subject" | translate}}</span>
                                    <span class="details-value">{{quotationSourceContent.email && quotationSourceContent.email.subject ? quotationSourceContent.email.subject : '--'}}</span>
                                </div>
                                <div *ngIf="quotation.channel === 'email'" class="details-row">
                                    <span class="details-label">{{"quotations_and_orders.source_content.from" | translate}}</span>
                                    <span class="details-value email_text">
                                        <span class="email-ellipsis"
                                            [matTooltip]="quotationSourceContent.email?.from ?? ''"
                                            matTooltipClass="product-status-tooltip email-tooltip"
                                            matTooltipPosition="above">{{quotationSourceContent.email?.from ?? '--'}}</span>
                                    </span>
                                </div>
                                <div *ngIf="quotation.channel === 'prompt'" class="details-row">
                                    <span class="details-label">{{"common.by" | translate}}</span>
                                    <span class="details-value email_text">{{quotationSourceContent.ai_details?.created_by ?? '--'}}</span>
                                </div>
                            </ng-container>
                            <div class="details-row">
                                <span class="details-label">{{"common.created_at" | translate}}</span>
                                <span class="details-value">{{quotationSourceContent.ai_details?.created_at | adaptToUserUtcOffset | date: DATE_FORMAT}}</span>
                            </div>
                        </div>
                        <hr *ngIf="quotationSourceContent.email?.content" class="details-divider"/>
                        <div class="customer-section">
                            <div class="email__message" [innerHTML]="quotationSourceContent.email?.content"></div>
                        </div>
                        <!-- <hr class="details-divider"/> -->
                        <ng-container *ngIf="quotationSourceContent.email && quotationSourceContent.email.attachments && quotationSourceContent.email.attachments.length > 0">
                            <div class="inline-block attachments-section">
                                <div class="email__label">{{"common.attachement" | translate}}</div>
                                <div class="attachments-container">
                                    <div class="attachment" *ngFor="let attachment of quotationSourceContent.email?.attachments"
                                        (click)="onAttachmentClick(attachment)"
                                        [class.attachment--selected]="isAttachmentSelected(attachment)"
                                        [title]="getAttachmentName(attachment)">
                                        <img src="assets/icones/attachment.svg" alt="">
                                        <span>
                                            {{
                                              (getAttachmentName(attachment) || '').length > 20
                                                ? (getAttachmentName(attachment) || '' | slice:0:17) + '...'
                                                : (getAttachmentName(attachment) || '')
                                            }}
                                          </span>
                                    </div>
                                </div>
                            </div>
                            <div class="attachment_preview" *ngIf="currentAttachment.length > 0">
                                <app-files-previewer
                                    [data]="currentAttachment"
                                >
                                </app-files-previewer>
                            </div>
                        </ng-container>
                        <div class="analysis-footer">
                            {{"quotations_and_orders.source_content.ai_can_make_errors" | translate}}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="details-quote" *ngIf="currentComponent === 'products'">
    <app-products-quote
        [catalogMaxExtraDiscount]="(quotation$ | async)?.pricelist_max_extra_discount || 0"
        [quoteProductsData]="quoteProductsData"
        (changeComponent)="setPage($event)"
        [availableCurrencies]="avalableCurrencies"
        [disableCurrency]="disableCurrency"
        [channel]="quotation?.channel || ''"
        (changeComponent)="currentComponent = $event"
        (updateQuoteProducts)="handleQuoteProductsUpdate($event)"
        (hasChanges)="handleQuoteChanges($event)"
        (formValid)="handleFormValidity($event)"
    >
    </app-products-quote>
</div>

<div class="details-quote" *ngIf="currentComponent === 'products-from-catalog'">
    <app-products-quote-from-catalog
        [existingProducts]="quoteProductsData.products || []"
        [pricelist_name]="quoteProductsData.pricelist_name"
        [currency]="quoteProductsData.currency"
        (selectedProducts)="handleSelectedProducts($event)"
    ></app-products-quote-from-catalog>
</div>

<div class="details-quote" *ngIf="currentComponent === 'products-from-all-products'">
    <app-products-quote-from-all-products
        [existingProducts]="quoteProductsData?.products || []"
        [currency]="quoteProductsData.currency"
        (selectedProducts)="handleSelectedProducts($event)"
    ></app-products-quote-from-all-products>
</div>

<app-stock-fulfillment
    *ngIf="quotation"
    [product]="selectedStockFulfillmentProduct"
    [visible]="isStockFulfillmentVisible"
    [order]="quotation"
    [canEdit]="false"
    [currentLanguage]="currentLanguage"
    [lineAlerts]="selectedStockFulfillmentProduct?.order_line_id ? (alertsByLine['' + selectedStockFulfillmentProduct!.order_line_id] || []) : []"
    (closed)="closeStockFulfillment()"
    (reservationChanged)="handleReservationChanged($event)"
></app-stock-fulfillment>

<div class="details-quote" *ngIf="currentComponent === 'explore_catalog'">
  <app-explore-catalog
       [location_id]="quotation?.location?.id || 0"
       (changeComponent)="goToCatalogProducts($event)"
    ></app-explore-catalog>
</div>
